import { environment } from "./environment"

export const URL = {
    API_BASE_URL: `${environment.apiBaseUrl}`
}

export const CONFIG = {
    AUTH: {
        LOGIN: `${URL.API_BASE_URL}/Users/login`,
        CREATEUSER: `${URL.API_BASE_URL}/Users/createUser`,
        CREATEUSERROLE: `${URL.API_BASE_URL}/Users/createUserRole`,
        UPDATEUSERROLE: `${URL.API_BASE_URL}/Users/updateUserRole`
    },
    USER: {
        GETMENUTREE: `${URL.API_BASE_URL}/Users/getUserMenuTree`,
        GETTENANTS: `${URL.API_BASE_URL}/Users/getAllTenants`,
        GETUSERBYUSER: `${URL.API_BASE_URL}/Users/getUserById`,
        UPDATEUSER: `${URL.API_BASE_URL}/Users/updateUserinfo`,
        DELETEUSER: `${URL.API_BASE_URL}/Users/deleteUser`,
        GET_ALLUSERS: `${URL.API_BASE_URL}/Users/UserList`,
        AUTOSEARCHUSERINFO: `${URL.API_BASE_URL}/Users/searchUserInfo`,
        GETUSERROLEBYID: `${URL.API_BASE_URL}/Users/getUserRoleById`,
        AUTOSEARCHROLE: `${URL.API_BASE_URL}/Role/searchRole`,
        REFRESHTOKEN: `${URL.API_BASE_URL}/Users/refreshToken`,
        GETACTIVEUSERS: `${URL.API_BASE_URL}/Users/UserList`,
        GETNOTIFICATIONS: `${URL.API_BASE_URL}/Notifications/Notifications`,
        GETNOTIFICATIONSERVICE: `${URL.API_BASE_URL}/Notification/GetNotifications`,
        MARKNOTIFICATIONSERVICE: `${URL.API_BASE_URL}/Notification/markNotification`,
        SEND_NOTIFICATION: `${URL.API_BASE_URL}/Notification/sendNotification`,
        LOGOUT: `${URL.API_BASE_URL}/Users/logout`, 
    },

    CUSTOMER: {
        GETALLCUSTOMER: `${URL.API_BASE_URL}/Customers/getCustomers`,
        GETCUSTOMER_FOR_ORDER: `${URL.API_BASE_URL}/Customers/getCustomerForOrder`,
        GETCUSTOMER: `${URL.API_BASE_URL}/Customers/getCustomer`,
        CREATECUSTOMER: `${URL.API_BASE_URL}/Customers/create`,
        UPDATECUSTOMER: `${URL.API_BASE_URL}/Customers/update`,
        UPDATECUSTOMEROUTSTANDREC: `${URL.API_BASE_URL}/Customers/updateOutstandingReceivables`,
        DELETECUSTOMER: `${URL.API_BASE_URL}/Customers/delete`,
        // AUTOGENERATE_CUSTOMERCODE: `${URL.API_BASE_URL}/Autogenerate/Customer`,
        AUTOGENERATE_CUSTOMERCODE: `${URL.API_BASE_URL}/Customers/generateCustomersNumber`,
        CHECK_CUSTOMER_CODE: `${URL.API_BASE_URL}/Customers/checkCustomerCode`,
        UPLOAD_CUST_IMAGE: `${URL.API_BASE_URL}/Customers/uploadCustomerImage`,
        GET_STATE_LIST: `${URL.API_BASE_URL}/Common/getStateList`,
        GET_TERMS_BY_CUSTOMER: `${URL.API_BASE_URL}/Customers/getTermByCustomerCode`,
        GET_CUSTOMER_BY_CODEORNAME: `${URL.API_BASE_URL}/Customers/getCustomerByCodeOrName`,

        CREATE_CUSTOMER_PRODUCT: `${URL.API_BASE_URL}/CustomerProduct/create`,
        GET_CUSTOMER_PRODUCT_LIST: `${URL.API_BASE_URL}/CustomerProduct/getCustomerProductCodeByCustomerId`,
        DELETE_CUSTOMER_PRODUCT: `${URL.API_BASE_URL}/CustomerProduct/delete`,
        GETOUTSTANDINGAMOUNT: `${URL.API_BASE_URL}/Customers/outstanding`,
        GET_GST_TREATENTS: `${URL.API_BASE_URL}/Customers/getGstTreatments`,
    },
    CONTACT: {
        CREATECONTACT: `${URL.API_BASE_URL}/Contact/create`,
        GETCONTACTBYCUSTOMER: `${URL.API_BASE_URL}/Contact/getCustomerContacts`,
        GETCONTACTBYSALESPERSON: `${URL.API_BASE_URL}/Contact/getSalespersonContacts`,
        GETCONTACTBYVENDOR: `${URL.API_BASE_URL}/Contact/getVendorsContacts`,
        DELETECONTACT: `${URL.API_BASE_URL}/Contact/delete`,
        GET_CONTACT_BYID: `${URL.API_BASE_URL}/Contact/GetContactsById`,
        UPDATE_CONTACT: `${URL.API_BASE_URL}/Contact/update`,
        GETCRMCONTACT: `${URL.API_BASE_URL}/Contact/getCRMContactslist`,
        AUTOSEARCHCRMCONTACT: `${URL.API_BASE_URL}/Contact/SearchCRMContact`,

    },
    SALESPERSON: {
        GETALLSALESPERSON: `${URL.API_BASE_URL}/Salesperson/getsalesperson`,
        GETSALESPERSON: `${URL.API_BASE_URL}/Salesperson/getSalesperson`,
        CREATESALESPERSON: `${URL.API_BASE_URL}/Salesperson/create`,
        UPDATESALESPERSON: `${URL.API_BASE_URL}/Salesperson/update`,
        DELETESALESPERSON: `${URL.API_BASE_URL}/Salesperson/delete`,
        // AUTOGENERATE_SALESPERSONCODE: `${URL.API_BASE_URL}/Autogenerate/SalesPerson`,
        AUTOGENERATE_SALESPERSONCODE: `${URL.API_BASE_URL}/Salesperson/generateSalespersonNumber`,
        CHECK_SALESPERSON_CODE: `${URL.API_BASE_URL}/Salesperson/checkSalespersonCode`,
        AUTOSEARCHSALESPERSON: `${URL.API_BASE_URL}/Salesperson/SearchSalespersonByCodeAndName`,
        UPLOAD_SALESPERSON_IMAGE: `${URL.API_BASE_URL}/Salesperson/uploadSalespersonImage`,
    },
    VENDOR: {
        GETALLVENDOR: `${URL.API_BASE_URL}/Vendor/getVendor`,
        GETVENDOR: `${URL.API_BASE_URL}/Vendor/getVendors`,
        CREATEVENDOR: `${URL.API_BASE_URL}/Vendor/create`,
        UPDATEVENDOR: `${URL.API_BASE_URL}/Vendor/update`,
        DELETEVENDOR: `${URL.API_BASE_URL}/Vendor/delete`,
        // AUTOGENERATE_VENDORCODE: `${URL.API_BASE_URL}/Autogenerate/Vendor`,
        AUTOGENERATE_VENDORCODE: `${URL.API_BASE_URL}/Vendor/generateVendorNumber`,
        CHECK_VENDOR_CODE: `${URL.API_BASE_URL}/Vendor/checkVendorCode`,
        AUTOSEARCHVENDOR: `${URL.API_BASE_URL}/Vendor/SearchVendorByCodeAndName`,
        UPLOAD_VENDOR_IMAGE: `${URL.API_BASE_URL}/Vendor/uploadImage`,
        GETVENDORLOOKUP: `${URL.API_BASE_URL}/Vendor/getVendor`,
        GETOUTSTANDINGAMOUNT: `${URL.API_BASE_URL}/Vendor/outstandingPayable`,

        //for vendor bank account
        CREATE_VENDOR_BANK: `${URL.API_BASE_URL}/VendorBank/createVendorBank`,
        UPDATE_VENDOR_BANK: `${URL.API_BASE_URL}/VendorBank/updateVendorBank`,
        GET_VENDOR_BANK: `${URL.API_BASE_URL}/VendorBank/getVendorBank`,
        DELETE_VENDOR_BANK: `${URL.API_BASE_URL}/VendorBank/deleteVendorBank`,
        SET_PRIMARY_BANK: `${URL.API_BASE_URL}/VendorBank/setPrimaryVendorBank`,

    },
    ADMINISTRATION: {
        GETALLROLES: `${URL.API_BASE_URL}/Role/getRole`,
        GETROLEBYID: `${URL.API_BASE_URL}/Role/getRoleById`,
        CREATEROLE: `${URL.API_BASE_URL}/Role/createRole`,
        DELETEROLE: `${URL.API_BASE_URL}/Role/deleteRole`,
        UPDATEROLE: `${URL.API_BASE_URL}/Role/update`,
        AUTOSEARCHCGST: `${URL.API_BASE_URL}/GST/searchGST`,

        GETROLEMENU: `${URL.API_BASE_URL}/AssignRoleMenu/GetRoleMenuById`,
        GETROLEMENUS: `${URL.API_BASE_URL}/AssignRoleMenu/getRoleMenus`,
        CREATEASSIGNROLE: `${URL.API_BASE_URL}/AssignRoleMenu/createAssignRole`,
        GET_ALLASSIGNROLES: `${URL.API_BASE_URL}/AssignRoleMenu/getAssignRole`,
        UPDATEASSIGNROLE: `${URL.API_BASE_URL}/AssignRoleMenu/updateAssignRole`,
        INACTIVEASSIGNROLE: `${URL.API_BASE_URL}/AssignRoleMenu/inActiveAssignRole`,
        GETASSIGNROLEBYID: `${URL.API_BASE_URL}/AssignRoleMenu/getAssignRolesByRoleId`,
        DELETEASSIGNROLE: `${URL.API_BASE_URL}/AssignRoleMenu/delete`,
        AUTOSEARCHASSIGNROLES: `${URL.API_BASE_URL}/AssignRoleMenu/searchAssignRole`,
        GETALLMENUS: `${URL.API_BASE_URL}/AssignRoleMenu/getAllMenus`,


        GETALLMENU: `${URL.API_BASE_URL}/Menu/getAllMenusWithSubmenus`,
        ADDMENU: `${URL.API_BASE_URL}/Menu/addmenu`,
        ADDSUBMENU: `${URL.API_BASE_URL}/Menu`,
        AUTOSEARCHMENU: `${URL.API_BASE_URL}/Menu/searchMenu`,


        GETALLUNITOFMEASURE: `${URL.API_BASE_URL}/UnitsofMeasure/getUnitsofMeasure`,
        GETUNITOFMEASURE: `${URL.API_BASE_URL}/UnitsofMeasure/GetUnitsofMeasures`,
        CREATEUNITOFMEASURE: `${URL.API_BASE_URL}/UnitsofMeasure/create`,
        UPDATEUNITOFMEASURE: `${URL.API_BASE_URL}/UnitsofMeasure/update`,
        DELETEUNITOFMEASURE: `${URL.API_BASE_URL}/UnitsofMeasure/delete`,
        AUTOSEARCHUMO: `${URL.API_BASE_URL}/UnitsofMeasure/searchUOM`,


        GETALLPAYMENTTERMS: `${URL.API_BASE_URL}/PaymentTerms/getPaymentTerms`,
        GETPAYMENTTERMS: `${URL.API_BASE_URL}/PaymentTerms/GetPaymentTerms`,
        CREATEPAYMENTTERMS: `${URL.API_BASE_URL}/PaymentTerms/create`,
        UPDATEPAYMENTTERMS: `${URL.API_BASE_URL}/PaymentTerms/update`,
        DELETEPAYMENTTERMS: `${URL.API_BASE_URL}/PaymentTerms/delete`,
        AUTOSEARCHPAYMENT: `${URL.API_BASE_URL}/PaymentTerms/searchPayment`,


        GETALLWAREHOUSE: `${URL.API_BASE_URL}/Warehouse/getWarehouses`,
        GETALLCOMPANYWAREHOUSE: `${URL.API_BASE_URL}/Warehouse/GetAllCompanyWarehouses`,
        GETWAREHOUSE: `${URL.API_BASE_URL}/Warehouse/getWarehouseById`,
        CREATEWAREHOUSE: `${URL.API_BASE_URL}/Warehouse/create`,
        UPDATEWAREHOUSE: `${URL.API_BASE_URL}/Warehouse/update`,
        DELETEWAREHOUSE: `${URL.API_BASE_URL}/Warehouse/delete`,
        AUTOSEARCHWAREHOUSE: `${URL.API_BASE_URL}/Warehouse/searchWarehouse`,
        GETCOMPANYWAREHOUSE: `${URL.API_BASE_URL}/Warehouse/getCompanyWarehouse`,
        AUTOSEARCHCOMPANYWAREHOUSE: `${URL.API_BASE_URL}/Warehouse/SearchWarehousesByComany`,
        GETWAREHOUSEBYCOMPANYID: `${URL.API_BASE_URL}/Warehouse/getWarehousesByCompanyId`,
        GETWMSLOCATIONS: `${URL.API_BASE_URL}/Warehouse/getWmsLocations`,
        GETWMSLOCATIONBYID: `${URL.API_BASE_URL}/Warehouse/getWmsLocationById`,
        CREATEWMSLOCATION: `${URL.API_BASE_URL}/Warehouse/createWmsLocation`,
        UPDATEWMSLOCATION: `${URL.API_BASE_URL}/Warehouse/updateWmsLocation`,
        DELETEWMSLOCATIONS: `${URL.API_BASE_URL}/Warehouse/deleteWmsLocations`,
        SEARCHWMSLOCATIONS: `${URL.API_BASE_URL}/Warehouse/searchWmsLocations`,
        GETPRODUCTLOCATIONS: `${URL.API_BASE_URL}/Warehouse/getProductLocations`,
        SAVEPRODUCTLOCATIONS: `${URL.API_BASE_URL}/Warehouse/saveProductLocations`,
        DELETEPRODUCTLOCATIONS: `${URL.API_BASE_URL}/Warehouse/deleteProductLocations`,

        GETMENU: `${URL.API_BASE_URL}/Menu/getMenu`,
        CREATEMENU: `${URL.API_BASE_URL}/Menu/creteMenu`,
        UPDATEMENU: `${URL.API_BASE_URL}/Menu/updateMenu`,
        DELETEMENU: `${URL.API_BASE_URL}/Menu/deleteMenu`,

        GET_GSTLIST: `${URL.API_BASE_URL}/GST/getGSTList`,
        CREATE_GST: `${URL.API_BASE_URL}/GST/create`,
        DELETE_GST: `${URL.API_BASE_URL}/GST/delete`,
        UPDATE_GST: `${URL.API_BASE_URL}/GST/update`,
        SEARCH_GST: `${URL.API_BASE_URL}/GST/search`,

        GET_PRODUCT_TYPE_BY_ID: `${URL.API_BASE_URL}/Product/getproducttypebyid`,
        CREATE_PRODUCT_TYPE: `${URL.API_BASE_URL}/Product/createproducttype`,
        UPDATE_PRODUCT_TYPE: `${URL.API_BASE_URL}/Product/updateproducttype`,
        DELETE_PRODUCT_TYPE: `${URL.API_BASE_URL}/Product/deleteproducttype`,
        SEARCH_PRODUCT_TYPE: `${URL.API_BASE_URL}/Product/searchProductType`,

        GETALLCOLOR: `${URL.API_BASE_URL}/Color/GetColor`,
        GETALLPRODUCTGROUPS: `${URL.API_BASE_URL}/ProductGroup/GetProductGroup`,
        GET_PRODUCTGROUPBYID: `${URL.API_BASE_URL}/ProductGroup/getProductGrouptById`,
        GET_COLORBYNAME: `${URL.API_BASE_URL}/Color/GetColorByName`,
        GET_GROUPBYNAME: `${URL.API_BASE_URL}/ProductGroup/GetProductGroupsByName`,
        GET_SUBCATEGORYBYNAME: `${URL.API_BASE_URL}/Product/GetSubCategoryByName`,

        GET_ALL_COLORS: `${URL.API_BASE_URL}/Color/GetColors`,

    },
    INVENTORY: {
        UPLOAD_IMAGE: `${URL.API_BASE_URL}/Product/uploadImage`,
        GET_IMAGE: `${URL.API_BASE_URL}/Product/getImage`,
        CREATEPRODUCT: `${URL.API_BASE_URL}/Product/create`,
        GET_PRODUCT: `${URL.API_BASE_URL}/Product/getproducts`,
        GET_EXPORT_PRODUCT: `${URL.API_BASE_URL}/Product/getPdfProductslist`,
        GET_PRODUCTBYID: `${URL.API_BASE_URL}/Product/getProduct`,
        GET_PRODUCTBYNAME: `${URL.API_BASE_URL}/Product/getProductByName`,
        UPDATE_PRODUCT: `${URL.API_BASE_URL}/Product/update`,
        DELETE_PRODUCT: `${URL.API_BASE_URL}/Product/delete`,
        AUTOGENERATE_PRODUCTCODE: `${URL.API_BASE_URL}/Autogenerate/Product`,
        AUTOGENERATE_PRODUCTCODENEW: `${URL.API_BASE_URL}/Product/nextproductcodenew`,
        //AUTOGENERATE_PROJECTNUMBER: `${URL.API_BASE_URL}/Autogenerate/Project`,
        AUTOGENERATE_PROJECTNUMBER: `${URL.API_BASE_URL}/ProjectBOM/generateProjectNumber`,
        CHECK_PRODUCTCODE: `${URL.API_BASE_URL}/Product/checkProductCode`,
        GET_NEXTPRODUCTCODE: `${URL.API_BASE_URL}/Product/getNextProductCodeByPrefix`,
        GET_PRODUCTBYCODE: `${URL.API_BASE_URL}/Product/getProductByCode`,

        GET_PRODUCT_TYPE: `${URL.API_BASE_URL}/Product/getproducttypes`,
        GET_PRODUCTTYPEYBYCODE: `${URL.API_BASE_URL}/Product/getProductsByType`,
        GET_CATEGORYLIST: `${URL.API_BASE_URL}/Product/getcategories`,
        GET_CATEGORYBYID: `${URL.API_BASE_URL}/Product/getcategorybyid`,
        CREATE_CATEGORY: `${URL.API_BASE_URL}/Product/createcategory`,
        UPDATE_CATEGORY: `${URL.API_BASE_URL}/Product/updatecategory`,
        DELETE_CATEGORY: `${URL.API_BASE_URL}/Product/deletecategory`,
        SEARCHPRODUCTCATEGORY: `${URL.API_BASE_URL}/Product/searchProductsCategory`,
        GET_ALL_PRODUCTGROUP: `${URL.API_BASE_URL}/Product/getAllProductGroup`,

        GET_PRODUCTGROUPLIST: `${URL.API_BASE_URL}/ProductGroup/getProductGroup`,
        GET_PRODUCTGROUPID: `${URL.API_BASE_URL}/ProductGroup/getProductGrouptById`,
        CREATE_PRODUCTGROUP: `${URL.API_BASE_URL}/ProductGroup/createproductgroup`,
        UPDATE_PRODUCTGROUP: `${URL.API_BASE_URL}/ProductGroup/updateproductgroup`,
        DELETE_PRODUCTGROUP: `${URL.API_BASE_URL}/ProductGroup/deleteproductgroup`,
        SEARCHPRODUCTGROUP: `${URL.API_BASE_URL}/ProductGroup/searchProductgroup`,

        CREATEBILLOFMATERIAL: `${URL.API_BASE_URL}/Billofmaterial/create`,
        GETALLBILLOFMATERIAL: `${URL.API_BASE_URL}/Billofmaterial/getAllBOM`,
        GETBILLOFMATERIAL: `${URL.API_BASE_URL}/Billofmaterial/getBOM`,
        SEARCHPROJECTLINEITM: `${URL.API_BASE_URL}/Billofmaterial/searchRawMaterial`,
        UPDATEBILLOFMATERIAL: `${URL.API_BASE_URL}/Billofmaterial/update`,
        DELETEBILLOFMATERIAL: `${URL.API_BASE_URL}/Billofmaterial/deleteBom`,
        UPDATEBOMLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/updatelineitem`,
        DELETEBOMLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/deletelineitem`,
        AUTOSEARCHBOM: `${URL.API_BASE_URL}/Billofmaterial/searchbom`,
        AUTOSEARCHRAWMATERIALPRODUCT: `${URL.API_BASE_URL}/Billofmaterial/search`,




        CREATEBILLOFMATERIALLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/createlineitem`,
        GETALLBILLOFMATERIALLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/getAllBOMlineitem`,
        GETBILLOFMATERIALLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/getBOMlineitem`,
        GETPROJECTBILLOFMATERIALLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/getProjectBOMLineitem`,
        UPDATEBILLOFMATERIALLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/updatelineitem`,
        DELETEBILLOFMATERIALLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/deleteBomlineitem`,

        // company information

        GET_COMPANY_DETAILS: `${URL.API_BASE_URL}/CompanyInfo/getCompanyDetails`,
        GETCOMPANYINFOBYID: `${URL.API_BASE_URL}/CompanyInfo/getCompanyInfoId`,
        GETALLCOMPANYINFO: `${URL.API_BASE_URL}/CompanyInfo/getAllCompanyInfo`,
        CREATECOMPANYINFO: `${URL.API_BASE_URL}/CompanyInfo/createCompanyinfo`,
        UPDATECOMPANYINFO: `${URL.API_BASE_URL}/CompanyInfo/updateCompanyinfo`,
        DELETE_COMPANY: `${URL.API_BASE_URL}/CompanyInfo/delete`,
        AUTOSEARCHCOMPANYINFO: `${URL.API_BASE_URL}/CompanyInfo/searchCompanyInfo`,
        AUTOGENERATE_COMPANYCODE: `${URL.API_BASE_URL}/CompanyInfo/searchCompanyInfo`,
        UPLOAD_COMPANY_IMAGE: `${URL.API_BASE_URL}/CompanyInfo/uploadCompanyLogo`,

        // Inventory

        CREATE_INVENTORY: `${URL.API_BASE_URL}/Inventory/create`,
        GET_INVENTORYSTATUS: `${URL.API_BASE_URL}/Inventory/get`,
        GET_INVENTORYSTATUSWAREHOUSE: `${URL.API_BASE_URL}/Inventory/getByWarehouseId`,
        GET_LEDGERSTATUS: `${URL.API_BASE_URL}/ProductLedger/getProdutLedger`,
        GET_LEDGERSTATUSBY_WAREHOUSEID: `${URL.API_BASE_URL}/ProductLedger/getProdutLedgerByWarehouse`,
        UPDATE_INVENTORY: `${URL.API_BASE_URL}/Inventory/update`,
        UPDATE_INVENTORY_NEW: `${URL.API_BASE_URL}/Inventory/updateInventory`,
        UPDATE_INVENTORYANDPROJECTLEDGER: `${URL.API_BASE_URL}/Inventory/UpdateInventoryAndProductLedger`,
        GET_INVENTORY_STATUS_BY_PRODUCT_WAREHOUSE: `${URL.API_BASE_URL}/Inventory/GetInventoryStatusByProductWarehouse`,

        CREATEPROJECT: `${URL.API_BASE_URL}/ProjectBOM/create`,
        UPDATEPROJECTBOM: `${URL.API_BASE_URL}/ProjectBOM/update`,
        GETALLPROJECTBOM: `${URL.API_BASE_URL}/ProjectBOM/getAllProjectBOM`,
        DELETEPROJECTBOM: `${URL.API_BASE_URL}/ProjectBOM/deleteProjectBom`,
        GETPROJECTBYID: `${URL.API_BASE_URL}/ProjectBOM/getProjectBOM`,
        GETPROJECTBYCODE: `${URL.API_BASE_URL}/ProjectBOM/getProjectBOMbyCode`,
        GETPROJECTTRANSACTIONS: `${URL.API_BASE_URL}/ProjectBOM/getProjectTransactions`,

        SEARCHPROJECT: `${URL.API_BASE_URL}/ProjectBOM/searchProjectbom`,
        GETPROJECTBYIDFORREPORT: `${URL.API_BASE_URL}/ProjectBOM/getProjectBOMForReport`,
        SEARCHMANUFACTURINGPROJECT: `${URL.API_BASE_URL}/ProjectManufacturingBatch/searchManufacturingProjectbom`,

        CREATE_MANUAL_INVENTORY: `${URL.API_BASE_URL}/InventoryAdjustment/createManualInventory`,
        GET_MANUAL_INVENTORY_LIST: `${URL.API_BASE_URL}/InventoryAdjustment/getInventoryAdjustment`,
        GET_INVENTORY_ADJUSTMENT_BY_ID: `${URL.API_BASE_URL}/InventoryAdjustment/GetInventoryAdjustmentById`,
        SEARCH_INVENTORY_ADJUSTMENT: `${URL.API_BASE_URL}/InventoryAdjustment/search`,

        // GL Posting
        GL_POST_INVENTORY_ADJUSTMENT: `${URL.API_BASE_URL}/GLPosting/InventoryAdjustment`,
        GL_POSTING_STATUS: `${URL.API_BASE_URL}/GLPosting/Status`,
        GL_ENTRIES_INVENTORY_ADJUSTMENT: `${URL.API_BASE_URL}/GLPosting/Entries/InventoryAdjustment`,
        GL_POST_GRN: `${URL.API_BASE_URL}/GLPosting/GRN`,
        GL_ENTRIES_GRN: `${URL.API_BASE_URL}/GLPosting/Entries/GRN`,
        GL_POST_VENDOR_BILL: `${URL.API_BASE_URL}/GLPosting/VendorBill`,
        GL_ENTRIES_VENDOR_BILL: `${URL.API_BASE_URL}/GLPosting/Entries/VendorBill`,
        GL_POST_VENDOR_PAYMENT: `${URL.API_BASE_URL}/GLPosting/VendorPayment`,
        GL_ENTRIES_VENDOR_PAYMENT: `${URL.API_BASE_URL}/GLPosting/Entries/VendorPayment`,
        GL_POST_PURCHASE_RETURN: `${URL.API_BASE_URL}/GLPosting/PurchaseReturn`,
        GL_ENTRIES_PURCHASE_RETURN: `${URL.API_BASE_URL}/GLPosting/Entries/PurchaseReturn`,
        GL_POST_SALES_RETURN: `${URL.API_BASE_URL}/GLPosting/SalesReturn`,
        GL_ENTRIES_SALES_RETURN: `${URL.API_BASE_URL}/GLPosting/Entries/SalesReturn`,
        GL_POST_SALES_INVOICE: `${URL.API_BASE_URL}/GLPosting/SalesInvoice`,
        GL_ENTRIES_SALES_INVOICE: `${URL.API_BASE_URL}/GLPosting/Entries/SalesInvoice`,

        // Product sub category
        GET_ALL_CATEGORY: `${URL.API_BASE_URL}/Product/getCategoryList`,
        GET_SUBCATEGORYLIST: `${URL.API_BASE_URL}/Product/getsubcategories`,
        GET_SUBCATEGORYBYID: `${URL.API_BASE_URL}/Product/getsubcategorybyid`,
        CREATE_SUBCATEGORY: `${URL.API_BASE_URL}/Product/createsubcategory`,
        UPDATE_SUBCATEGORY: `${URL.API_BASE_URL}/Product/updatesubcategory`,
        DELETE_SUBCATEGORY: `${URL.API_BASE_URL}/Product/deletesubcategory`,
        SEARCHPRODUCTSUBCATEGORY: `${URL.API_BASE_URL}/Product/searchsubcategory`,
        AUTOGENERATE_SUBCATEGORYCODE: `${URL.API_BASE_URL}/Autogenerate/SubCategory`,
        CHECK_SUBCATEGORY_CODE: `${URL.API_BASE_URL}/Product/checksubCategoryCode`,

        //Project Task
        GET_ALL_COMPANY: `${URL.API_BASE_URL}/ProjectTask/getCompanyList`,
        GET_ALL_PROJECT: `${URL.API_BASE_URL}/ProjectTask/getProjectList`,
        GET_ALL_USER: `${URL.API_BASE_URL}/ProjectTask/GetUserList`,
        GET_PROJECTTASKLIST: `${URL.API_BASE_URL}/ProjectTask/getProjectTask`,
        GET_PROJECTTASKBYID: `${URL.API_BASE_URL}/ProjectTask/getProjectTaskbyid`,
        CREATE_PROJECTTASK: `${URL.API_BASE_URL}/ProjectTask/createProjectTask`,
        UPDATE_PROJECTTASK: `${URL.API_BASE_URL}/ProjectTask/updateProjectTask`,
        UPDATEPRIORITY: `${URL.API_BASE_URL}/ProjectTask/updatepriority`,
        DELETE_PROJECTTASK: `${URL.API_BASE_URL}/ProjectTask/deleteProjectTask`,
        SEARCHPROJECTTASK: `${URL.API_BASE_URL}/ProjectTask/searchProjectTask`,
        //AUTOGENERATE_PROJECTTASKCODE: `${URL.API_BASE_URL}/Autogenerate/ProjectTask`,
        AUTOGENERATE_PROJECTTASKCODE: `${URL.API_BASE_URL}/ProjectTask/generateProjectTaskNumber`,
        CHECK_PROJECTTASK_CODE: `${URL.API_BASE_URL}/ProjectTask/checkProjectTaskCode`,
        GET_PROJECTTASK_LIST_BY_REMINDER: `${URL.API_BASE_URL}/ProjectTask/getProjectTaskListByReminder`,
        GET_GETISCLOSEDBYID: `${URL.API_BASE_URL}/ProjectTask/getIsClosedCount`,

        //Project Timesheet (Created By Nilesh)
        //AUTOGENERATE_TIMESHEETCODE: `${URL.API_BASE_URL}/Autogenerate/Timesheets`,
        AUTOGENERATE_TIMESHEETCODE: `${URL.API_BASE_URL}/Timesheet/generateProjectTimesheetsNumber`,
        CREATE_PROJECTTIMESHEET: `${URL.API_BASE_URL}/Timesheet/createProjectTimesheet`,
        GET_PROJECTTIMESHEETLIST: `${URL.API_BASE_URL}/Timesheet/getProjectTimesheet`,
        GET_PROJECTTIMESHEETBYID: `${URL.API_BASE_URL}/Timesheet/getProjectTimesheetByid`,
        DELETE_PROJECTTIMESHEET: `${URL.API_BASE_URL}/Timesheet/deleteProjectTimesheet`,
        UPDATE_PROJECTTIMESHEET: `${URL.API_BASE_URL}/Timesheet/updateProjectTimesheet`,
        CHECK_PROJECTTIMESHEET_CODE: `${URL.API_BASE_URL}/Timesheet/checkProjectTimesheetCode`,
        GET_TIMESHEETCALLAPPOINTMENT: `${URL.API_BASE_URL}/Timesheet/getTimesheetCallByAppointment`,

        //HRMS Timesheet (Created By Nilesh)
        AUTOGENERATE_HRMSTIMESHEETCODE: `${URL.API_BASE_URL}/Autogenerate/HRMSTimesheets`,
        CREATE_HRMSTIMESHEET: `${URL.API_BASE_URL}/HRMSTimesheet/createHRMSTimesheet`,
        GET_HRMSTIMESHEETLIST: `${URL.API_BASE_URL}/HRMSTimesheet/getHRMSTimesheet`,
        GET_HRMSTIMESHEETBYID: `${URL.API_BASE_URL}/HRMSTimesheet/getHRMSTimesheetByid`,
        UPDATE_HRMSTTIMESHEET: `${URL.API_BASE_URL}/HRMSTimesheet/updateHRMSTimesheet`,
        CHECK_HRMSTIMESHEET_CODE: `${URL.API_BASE_URL}/HRMSTimesheet/checkHRMSTimesheetCode`,
        DELETE_HRMSTIMESHEET: `${URL.API_BASE_URL}/HRMSTimesheet/deleteHRMSTimesheet`,
        GET_HRMSTIMESHEETCALLAPPOINTMENT: `${URL.API_BASE_URL}/HRMSTimesheet/getHRMSTimesheetCallByAppointment`,


        //Project Task Comment
        ADD_PROJECTTASK_COMMENT: `${URL.API_BASE_URL}/ProjectTaskComment/addProjectTaskComment`,
        UPDATE_PROJECTTASK_COMMENT: `${URL.API_BASE_URL}/ProjectTaskComment/updateProjectTaskComment`,
        DELETE_PROJECTTASK_COMMENT: `${URL.API_BASE_URL}/ProjectTaskComment/deleteProjectTaskComment`,
        GET_PROJECTTASK_COMMENTS_BYTaskCode: `${URL.API_BASE_URL}/ProjectTaskComment/getProjectTaskCommentsByTaskCode`,
        GET_PROJECTTASK_COMMENTS_BYTaskID: `${URL.API_BASE_URL}/ProjectTaskComment/getProjectTaskCommentsByTaskId`,
        GET_PROJECTTASKFORTIMESHEET: `${URL.API_BASE_URL}/Timesheet/getProjectForTimesheet`,


        //Project Phase
        GET_PROJECTPHASELIST: `${URL.API_BASE_URL}/ProjectPhase/getProjectPhase`,
        GET_PROJECTPHASEBYID: `${URL.API_BASE_URL}/ProjectPhase/getProjectPhasebyid`,
        CREATE_PROJECTPHASE: `${URL.API_BASE_URL}/ProjectPhase/createProjectPhase`,
        UPDATE_PROJECTPHASE: `${URL.API_BASE_URL}/ProjectPhase/updateProjectPhase`,
        DELETE_PROJECTPHASE: `${URL.API_BASE_URL}/ProjectPhase/deleteProjectPhase`,
        SEARCHPROJECTPHASE: `${URL.API_BASE_URL}/ProjectPhase/searchProjectPhase`,
        // AUTOGENERATE_PROJECTPHASECODE: `${URL.API_BASE_URL}/Autogenerate/ProjectPhase`,
        AUTOGENERATE_PROJECTPHASECODE: `${URL.API_BASE_URL}/ProjectPhase/generateProjectPhaseNumber`,
        CHECK_PROJECTPHASE_CODE: `${URL.API_BASE_URL}/ProjectPhase/checkProjectPhaseCode`,
        GET_PROJECTTASKPROJECTLIST: `${URL.API_BASE_URL}/ProjectPhase/getProjectTaskByProject`,
        SEARCH_PROJECTTASKPROJECTLIST: `${URL.API_BASE_URL}/ProjectPhase/searchProjectTask`,
        GET_PHASES_CALENDER: `${URL.API_BASE_URL}/ProjectPhase/getPhasesForCalender`,


        //ProjectPhase ImportedTask
        GET_PROJECTPHASEIMPORTEDTASK_LIST: `${URL.API_BASE_URL}/ProjectPhaseImportedTask/getProjectPhaseImportedTask`,
        ADD_PROJECTPHASEIMPORTEDTASK: `${URL.API_BASE_URL}/ProjectPhaseImportedTask/createProjectPhaseImportedTask`,
        DELETE_PROJECTPHASEIMPORTEDTASK: `${URL.API_BASE_URL}/ProjectPhaseImportedTask/DeleteProjectPhaseImportedTask`,
        GET_PROJECTPHASEIMPORTEDTASK_BYTaskID: `${URL.API_BASE_URL}/ProjectPhaseImportedTask/getProjectPhaseImportedTaskById`,
        GET_PROJECTPHASEIMPORTEDTASK_BYPhaseID: `${URL.API_BASE_URL}/ProjectPhaseImportedTask/getCompletionByPhase`,

        //Project Phase Comment
        ADD_PROJECTPHASE_COMMENT: `${URL.API_BASE_URL}/ProjectPhaseComment/addProjectPhaseComment`,
        UPDATE_PROJECTPHASE_COMMENT: `${URL.API_BASE_URL}/ProjectPhaseComment/updateProjectPhaseComment`,
        DELETE_PROJECTPHASE_COMMENT: `${URL.API_BASE_URL}/ProjectPhaseComment/deleteProjectPhaseComment`,
        GET_PROJECTPHASE_COMMENTS_BYTaskCode: `${URL.API_BASE_URL}/ProjectPhaseComment/getProjectPhaseCommentsByTaskCode`,
        GET_PROJECTPHASE_COMMENTS_BYTaskID: `${URL.API_BASE_URL}/ProjectPhaseComment/getProjectPhaseCommentsByTaskId`,

        //Vendor Bill
        //AUTOGENERATE_VENDORBILLCODE: `${URL.API_BASE_URL}/Autogenerate/VendorBill`,
        AUTOGENERATE_VENDORBILLCODE: `${URL.API_BASE_URL}/VendorBill/generateVendorBillNumber`,
        GET_VENDORBILLLIST: `${URL.API_BASE_URL}/VendorBill/getVendorBill`,
        GET_VENDORBILLBYID: `${URL.API_BASE_URL}/VendorBill/getVendorBillbyid`,
        CREATE_VENDORBILL: `${URL.API_BASE_URL}/VendorBill/createVendorBill`,
        UPDATE_VENDORBILL: `${URL.API_BASE_URL}/VendorBill/updateVendorBill`,
        DELETE_VENDORBILL: `${URL.API_BASE_URL}/VendorBill/deleteVendorBill`,
        SEARCHPVENDORBILL: `${URL.API_BASE_URL}/VendorBill/searchVendorBill`,
        CHECK_VENDORBILL_CODE: `${URL.API_BASE_URL}/VendorBill/checkVendorBillCode`,
        UPDATE_VENDORBILLSTATUS: `${URL.API_BASE_URL}/VendorBill/UpdateVendorBillStatus`,
        GET_PO_RECEIPT_RETURNPO: `${URL.API_BASE_URL}/VendorBill/getPOReceiptForReturnPO`,

        //void vendor Bill
        VOID_VENDOR_BILL: `${URL.API_BASE_URL}/VendorBill/voidVendorBill`,

        //Vendor Payment
        //AUTOGENERATE_VENDORPAYMENTCODE: `${URL.API_BASE_URL}/Autogenerate/VendorPayment`,
        AUTOGENERATE_VENDORPAYMENTCODE: `${URL.API_BASE_URL}/VendorPayment/generateVendorPaymentNumber`,
        CHECK_VENDORPAYMENT_CODE: `${URL.API_BASE_URL}/VendorPayment/checkVendorPaymentCode`,
        CREATE_VENDORPAYMENT: `${URL.API_BASE_URL}/VendorPayment/createVendorPayment`,
        UPDATE_VENDORPAYMENT: `${URL.API_BASE_URL}/VendorPayment/updateVendorPayment`,
        DELETE_VENDORPAYMENT: `${URL.API_BASE_URL}/VendorPayment/deleteVendorPayment`,
        SEARCH_VENDORPAYMENT: `${URL.API_BASE_URL}/VendorPayment/searchVendorPayment`,
        GET_VENDORPAYMENTLIST: `${URL.API_BASE_URL}/VendorPayment/getVendorPayment`,
        GET_VENDORPAYMENTBYID: `${URL.API_BASE_URL}/VendorPayment/getVendorPaymentbyid`,
        GET_OPENIVENDORBILL_BY_VENDORCODE: `${URL.API_BASE_URL}/VendorPayment/getARByCustomer`,

        UPDATE_ACCOUNTPAYABLE: `${URL.API_BASE_URL}/VendorPayment/updateAccountPayable`,
        UPDATE_MULTIPLE_ACCOUNTPAYABLES: `${URL.API_BASE_URL}/VendorPayment/updateMultipleAccountPayables`,
        GET_ACCOUNTPAYABLE_LINEITEM_BY_PRNO: `${URL.API_BASE_URL}/VendorPayment/getAPLineItemByPRNo`,
        CREATE_VENDORPAYMENT_LINEITEM: `${URL.API_BASE_URL}/VendorPayment/createVendorPaymentLineItems`,
        GET_VENDORBILL_BY_VENDORBILLCODE: `${URL.API_BASE_URL}/VendorPayment/getVendorBillByVendorBillCode`,
        GET_VENDORPYAMENTLINEITEM_BY_VENDORPAYMENTCODE: `${URL.API_BASE_URL}/VendorPayment/getVendorPaymentLineItemByVendorPaymentCode`,
        GET_VENDORPMTLINEITEM_BY_PAYMENT: `${URL.API_BASE_URL}/VendorPayment/getVendorPaymentLineItemsByPayment`,
        UPDATE_MULTIPLE_VENDORPMTLINEITEM: `${URL.API_BASE_URL}/VendorPayment/updateVendorPaymentLineItems`,
        UPDATE_VENDORPAYMENTSTATUS: `${URL.API_BASE_URL}/VendorPayment/UpdateVendorPaymentStatus`,
        UPDATE_MULTIPLEVENDORPAYMENTSTATUS: `${URL.API_BASE_URL}/VendorPayment/updateMultipleVendorBillStatus`,
        GET_UNPROCESSED_PAYMENT_SUM: `${URL.API_BASE_URL}/VendorPayment/getUnprocessedPaymentSum`,
        GET_TOTAL_SAVED_PAYMENTS_FOR_BILL: `${URL.API_BASE_URL}/VendorPayment/getTotalSavedPaymentsForBill`,
        GET_VENDORLINEITEMBY_PAYMENT_ID: `${URL.API_BASE_URL}/VendorPayment/getVendorPaymentLineItemsByPaymentId`,

        // For vendor credit
        GETVENDORCREDITS: `${URL.API_BASE_URL}/VendorPayment/getAdvanceVendorPayments`,
        GET_APPLIED_VENDOR_CREDITS_BY_BILL: `${URL.API_BASE_URL}/VendorPayment/getAppliedVendorCreditsByBill`,
        APPLY_VENDOR_CREDITS: `${URL.API_BASE_URL}/VendorPayment/applyVendorCredits`,
        GET_ACCOUNTPAYABLE_BY_BILLID: `${URL.API_BASE_URL}/VendorPayment/getAccountPayableByBillId`,

        // Void_Vendor Payment

        VOID_VENDOR_PAYMENT: `${URL.API_BASE_URL}/VendorPayment/voidVendorPayment`,


        //Proposal
        //AUTOGENERATE_PROPOSALCODE: `${URL.API_BASE_URL}/Autogenerate/Proposal`,
        AUTOGENERATE_PROPOSALCODE: `${URL.API_BASE_URL}/Proposal/generateProposalNumber`,
        CHECK_PROPOSAL_CODE: `${URL.API_BASE_URL}/Proposal/checkProposalCode`,
        GET_PROPOSALLIST: `${URL.API_BASE_URL}/Proposal/GetProposal`,
        GET_PROPOSALBYID: `${URL.API_BASE_URL}/Proposal/GetProposalById`,
        CREATE_PROPOSAL: `${URL.API_BASE_URL}/Proposal/createProposal`,
        UPDATE_PROPOSAL: `${URL.API_BASE_URL}/Proposal/updateProposal`,
        DELETE_PROPOSAL: `${URL.API_BASE_URL}/Proposal/deleteProposal`,
        SEARCHPROPOSAL: `${URL.API_BASE_URL}/Proposal/searchProposal`,

        //Proposal LineItem
        GET_PROPOSAL_LINEITEM_BYID: `${URL.API_BASE_URL}/Proposal/GetProposalLineItemById`,
        CREATEPROPOSAL_LINEITEM: `${URL.API_BASE_URL}/Proposal/createproposalLineItem`,
        UPDATE_PROPOSAL_LINEITEM: `${URL.API_BASE_URL}/Proposal/updateProposalLineItem`,
        DELETE_PROPOSAL_LINEITEM: `${URL.API_BASE_URL}/Proposal/deleteProposalLineItem`,
        MARK_PROPOSAL_INVOICED: `${URL.API_BASE_URL}/Proposal/MarkProposalInvoiced`,
        //Proposal template
        AUTOGENERATE_PROPOSALTEMPLATECODE: `${URL.API_BASE_URL}/Autogenerate/ProposalTemplate`,
        CHECK_PROPOSALTEMPLATE_CODE: `${URL.API_BASE_URL}/Proposal/checkProposalTemplateCode`,
        GET_PROPOSALTEMPLATE_LIST: `${URL.API_BASE_URL}/Proposal/GetProposalTemplate`,
        SEARCH_PROPOSALTEMPLATE: `${URL.API_BASE_URL}/Proposal/SearchProposalTemplate`,
        CREATE_PROPOSALTEMPLATE: `${URL.API_BASE_URL}/Proposal/createProposalTemplate`,

        //Proposal Desing basis
        GET_PROPOSALDESGINBASISBYID: `${URL.API_BASE_URL}/Proposal/GetProposalDesignBasisById`,
        CREATE_PROPOSALDESGINBASIS: `${URL.API_BASE_URL}/Proposal/createProposalDesignBasis`,
        UPDATE_PROPOSALDESGINBAS: `${URL.API_BASE_URL}/Proposal/updateProposalDesignBasis`,
    },
    SALES: {
        AUTOSEARCHPRODUCT: `${URL.API_BASE_URL}/Product/search`,
        AUTOSEARCHCUSTOMERS: `${URL.API_BASE_URL}/Customers/SearchCustomerByCodeAndName/`,

        // AUTOGENERATE_SALESORDERNUMBER: `${URL.API_BASE_URL}/Autogenerate/Order`,
        AUTOGENERATE_SALESQUOTENUMBER: `${URL.API_BASE_URL}/SalesOrder/generateQuoteNumber`,
        AUTOGENERATE_SALESORDERNUMBER: `${URL.API_BASE_URL}/SalesOrder/generateOrderNumber`,
        AUTOGENERATE_SALESINVOICENUMBER: `${URL.API_BASE_URL}/SalesOrder/generateInvoiceNumber`,
        AUTOGENERATE_DCNUMBER: `${URL.API_BASE_URL}/DeliveryChallan/generateDCNumber`,
        GET_SALESORDERLIST: `${URL.API_BASE_URL}/SalesOrder/getSalesOrders`,
        GET_INVOICEORDER_BYSTATUS: `${URL.API_BASE_URL}/SalesOrder/getInvoiceOrderStatus`,
        SEARCH_SALESORDER: `${URL.API_BASE_URL}/SalesOrder/searchSalesOrder`,
        CREATE_SALESORDER: `${URL.API_BASE_URL}/SalesOrder/create`,
        UPDATE_SALESORDER: `${URL.API_BASE_URL}/SalesOrder/update`,
        UPDATE_SALESORDER_NEW: `${URL.API_BASE_URL}/SalesOrder/UpdateSalesOrderNew`,
        DELETE_SALESORDER: `${URL.API_BASE_URL}/SalesOrder/delete`,
        GET_SALESORDER_BYSTATUS: `${URL.API_BASE_URL}/SalesOrder/getSalesOrderStatus`,
        GET_SALESORDER_BYID: `${URL.API_BASE_URL}/SalesOrder/getSalesOrderById`,
        GET_SALESORDER_BY_NUMBER: `${URL.API_BASE_URL}/SalesOrder/getSalesOrderBySalesOrderNumber`,
        GET_SALESORDERLINEITEM_BYID: `${URL.API_BASE_URL}/SalesOrder/getSalesOrderLineItemById`,
        UPDATE_INVOICEBILLSTATUS: `${URL.API_BASE_URL}/SalesOrder/UpdateInvoiceBillStatus`,

        // GET_SALESORDER_LINEITEMS: `${URL.API_BASE_URL}/SalesOrder/getSalesOrderLineItems`,
        GET_SALESORDER_LINEITEMS: `${URL.API_BASE_URL}/SalesOrder/getSalesOrderNumberByLineItem`,
        CREATE_SALESORDER_LINEITEM: `${URL.API_BASE_URL}/SalesOrder/createSalesOrderLineItem`,
        UPDATE_SALESORDER_LINEITEM: `${URL.API_BASE_URL}/SalesOrder/updateSalesOrderLineItem`,
        DELETE_SALESORDER_LINEITEM: `${URL.API_BASE_URL}/SalesOrder/DeleteSalesOrderLineItem`,

        CHECK_SALESORDER_NUMBER: `${URL.API_BASE_URL}/SalesOrder/checkSalesOrderNumber`,

        GET_BO_TRANSACTION: `${URL.API_BASE_URL}/SalesOrder/searchBOTransaction`,

        GET_INVOICEORDER_NUMBER: `${URL.API_BASE_URL}/EInvoice/getByOrderNumber`,
        CREATE_SALESORDERWITHAR: `${URL.API_BASE_URL}/SalesOrder/CreateSalesOrderWithARAsync`,
        CREATE_SALESORDERWITHARNEW: `${URL.API_BASE_URL}/SalesOrder/CreateSalesOrderWithARAsyncNew`,
        // mail end-points

        SEND_MAIL: `${URL.API_BASE_URL}/Mail/SendMail`,
        SEND_SUPPORT_MAIL: `${URL.API_BASE_URL}/Mail/SendSupportRequest`,
        GET_EMAIL_TEMPLATE: `${URL.API_BASE_URL}/Mail`,
        GET_EMAIL_TEMPLATE_BY_ID: `${URL.API_BASE_URL}/Mail/getEmailTemplateById`,
        GET_EMAIL_TEMPLATE_BY_NAME: `${URL.API_BASE_URL}/Mail/GetEmailTemplateByName`,
        // linked files

        CREATE_LINKEDFILE: `${URL.API_BASE_URL}/SalesOrder/createLinkedFile`,
        LINKEDFILEBYORDERID: `${URL.API_BASE_URL}/SalesOrder/getLinkedFileOrderById`,
        UPDATE_LINKEDFILE: `${URL.API_BASE_URL}/SalesOrder/updateLinkedFile`,
        LINKEDFILEBYID: `${URL.API_BASE_URL}/SalesOrder/getLinkedFileById`,
        DELETE_LINKEDFILE: `${URL.API_BASE_URL}/SalesOrder/deleteLinkedFile`,

        // Recent Interactions

        CREATE_RECENTINTERACTIONS: `${URL.API_BASE_URL}/RecentInteractions/createrecentInteractions`,
        RECENTINTERACTIONSBYID: `${URL.API_BASE_URL}/RecentInteractions/getrecentInteractionsById`,
        RECENTINTERACTIONSBYVENDORNUMBER: `${URL.API_BASE_URL}/RecentInteractions/getrecentInteractionsByVendor`,
        GETFILTEREDDATA: `${URL.API_BASE_URL}/RecentInteractions/search-recent-interactions`,
        CREATE_SUPPORT_MAIL: `${URL.API_BASE_URL}/RecentInteractions/createSupport`,
        GETRECENTINTERACTIONSBYCRM: `${URL.API_BASE_URL}/RecentInteractions/getRecentInteractionsByCRM`,
        GET_SALESORDERS_BY_NUMBER: `${URL.API_BASE_URL}/SalesOrder/getSalesOrdersBySalesOrderNumber`,
        GET_INVOICE_CUSTOMER_EMAILS: `${URL.API_BASE_URL}/SalesOrder/getInvoiceCustomerEmails`,
        GET_INVOICE_REMINDER_DATA: `${URL.API_BASE_URL}/SalesOrder/getInvoiceReminderData`,
        GET_BILL_REMINDER_DATA: `${URL.API_BASE_URL}/SalesOrder/getBillReminderData`,

        // Sales Return

        GET_INVOICEORDER_FORSALESRETURN: `${URL.API_BASE_URL}/SalesOrderReturn/getInvoiceOrderForSalesReturn`,
        CREATE_SALESRETURN: `${URL.API_BASE_URL}/SalesOrderReturn/createSalesReturn`,
        UPDATE_SALESRETURN: `${URL.API_BASE_URL}/SalesOrderReturn/updateSalesReturn`,
        DELETE_SALESRETURN: `${URL.API_BASE_URL}/SalesOrderReturn/deleteSalesReturn`,
        VOID_SALESRETURN: `${URL.API_BASE_URL}/SalesOrderReturn/voidSalesReturn`,
        GET_SALESRETURN: `${URL.API_BASE_URL}/SalesOrderReturn/getSalesReturn`,
        GET_SALESRETURN_BYID: `${URL.API_BASE_URL}/SalesOrderReturn/getSalesReturnById`,
        CREATE_SALESRETURN_LINEITEM: `${URL.API_BASE_URL}/SalesOrderReturn/createSalesReturnLineItem`,
        UPDATE_SALESRETURN_LINEITEM: `${URL.API_BASE_URL}/SalesOrderReturn/updateSalesReturnLineItem`,
        GET_SALESRETURN_LINEITEM_BYID: `${URL.API_BASE_URL}/SalesOrderReturn/getSalesReturnLineItemById`,
        DELETE_SALESRETURN_LINEITEM: `${URL.API_BASE_URL}/SalesOrderReturn/deleteSalesReturnLineItem`,
        SEARCH_SALESRETURN: `${URL.API_BASE_URL}/SalesOrderReturn/searchSalesReturn`,
        REFUND_SALESRETURN: `${URL.API_BASE_URL}/SalesOrderReturn/refundSalesReturn`,
        GET_ALREADY_RETURNED_QTY: `${URL.API_BASE_URL}/SalesOrderReturn/getAlreadyReturnedQty`,
        AUTOGENERATE_SALESRETURNSNUMBER: `${URL.API_BASE_URL}/SalesOrderReturn/generateReturnNumber`,
        GET_FINICIALYEAR: `${URL.API_BASE_URL}/FinancialYear/current`,
        GET_FINICIALYEAR_BYDATE: `${URL.API_BASE_URL}/FinancialYear/get-by-date`,
    },
    PURCHASEORDER: {

        GETDEPARTMENT: `${URL.API_BASE_URL}/Department/getDepartments`,
        GETDEPARTMENT_ID: `${URL.API_BASE_URL}/Department/getDepartment`,
        AUTOSEARCHPO: `${URL.API_BASE_URL}/Purchaseorder/search`,


        // GETMAUALENTERY: `${URL.API_BASE_URL}/Purchaseorder/AutogeneratePurchaseOrderNumber`,
        AUTOGENERATE_PONUMBER: `${URL.API_BASE_URL}/Autogenerate/PurchaseOrder`,

        CREATEPURCHASEORDER: `${URL.API_BASE_URL}/Purchaseorder/create`,
        CREATEPMOFORSPARSH: `${URL.API_BASE_URL}/ProjectManufacturingBatch/createMBOMforsparsh`,
        GET_PURCHASEORDER: `${URL.API_BASE_URL}/Purchaseorder/getPurchaseOrders`,
        GET_PURCHASEORDERBYREADY: `${URL.API_BASE_URL}/Purchaseorder/getPurchaseOrdersbyReady`,
        GET_PURCHASEORDER_BYID: `${URL.API_BASE_URL}/Purchaseorder/getPurchaseOrderById`,
        UPDATE_PURCHASEORDER: `${URL.API_BASE_URL}/Purchaseorder/update`,
        DELETE_PURCHASEORDER: `${URL.API_BASE_URL}/Purchaseorder/delete`,

        CREATEPURCHASEORDER_LINEITEM: `${URL.API_BASE_URL}/Purchaseorder/createPurchaseOrderLineItem`,
        GET_PURCHASEORDER_LINEITEM: `${URL.API_BASE_URL}/Purchaseorder/getPurchaseOrderLineItems`,
        GET_PURCHASEORDER_BYID_LINEITEM: `${URL.API_BASE_URL}/Purchaseorder/getPurchaseOrderLineItemById`,
        UPDATE_PURCHASEORDER_LINEITEM: `${URL.API_BASE_URL}/Purchaseorder/updatePurchaseOrderLineItem`,
        DELETE_PURCHASEORDER_LINEITEM: `${URL.API_BASE_URL}/Purchaseorder/DeletePurchaseOrderLineItem`,
        UPDATE_PURCHASEORDER_STATUS: `${URL.API_BASE_URL}/Purchaseorder/updatePOStatus`,
        UPDATE_PURCHASEORDER_STATUS_FOR_POADMIN: `${URL.API_BASE_URL}/Purchaseorder/updatePOStatusForPoAdmin`,

        CHECK_PURCHASEORDER_NO: `${URL.API_BASE_URL}/PurchaseOrder/checkPurchaseOrderNumber`,

        //PO Receipt
        GET_PO_RECEIPT_HEADER: `${URL.API_BASE_URL}/POReceipt/getPOReceiptHeader`,
        GET_PO_RECEIPT_HEADER_BYID: `${URL.API_BASE_URL}/POReceipt/GetPOReceiptHeaderById`,
        GET_PO_RECEIPT_HEADER_BY_RECEIPT_NUMBER: `${URL.API_BASE_URL}/POReceipt/getPOReceiptHeaderByReceiptNumber`,
        GET_PO_RECEIPT_LINEITEM_BYPONUMBER: `${URL.API_BASE_URL}/POReceipt/getPOReceiptLineItemByPONumber`,
        CREATE_PO_RECEIPT_HEADER: `${URL.API_BASE_URL}/POReceipt/createPOReceiptHeader`,
        CREATE_PO_RECEIPT_HEADER_AND_LINE_ITEM: `${URL.API_BASE_URL}/POReceipt/createPOReceiptHeaderandLineItem`,
        UPDATE_PO_RECEIPT_HEADER: `${URL.API_BASE_URL}/POReceipt/updatePOReceiptHeader`,
        CREATE_PO_RECEIPT_LINEITEM: `${URL.API_BASE_URL}/POReceipt/createPOReceiptLineItem`,
        UPDATE_PO_RECEIPT_LINEITEM: `${URL.API_BASE_URL}/POReceipt/updatePOReceiptLineItem`,
        DELETE_PO_RECEIPTHEADER: `${URL.API_BASE_URL}/POReceipt/delete`,
        DELETE_PO_RECEIPT_LINEITEM: `${URL.API_BASE_URL}/POReceipt/deletePOReceiptLineItem`,
        AUTOGENERATE_RECEIPTNUMBER: `${URL.API_BASE_URL}/Autogenerate/Receipt`,
        SEARCH_PO_RECEIPT_HEADER: `${URL.API_BASE_URL}/POReceipt`,
        GET_NEXTPONUMBER: `${URL.API_BASE_URL}/POReceipt/getnextPoReceiptNumber`,
        SEARCH_PO_RECEIPT_RETURNPO: `${URL.API_BASE_URL}/POReceipt/searchForReturnPO`,
        GET_PO_RECEIPT_RETURNPO: `${URL.API_BASE_URL}/POReceipt/getPOReceiptForReturnPO`,
        GET_LAST_COST: `${URL.API_BASE_URL}/POReceipt/GetLastCost`,
        GET_CONSUMED_PO_LINE_DISCOUNT: `${URL.API_BASE_URL}/POReceipt/getConsumedPOLineDiscount`,

        // Manufacturing Orders api's
        CREATEMO: `${URL.API_BASE_URL}/ManufacturingBatch/create`,
        CREATEMOLINEITEMS: `${URL.API_BASE_URL}/ManufacturingBatch/createlineitem`,
        GETALLMO: `${URL.API_BASE_URL}/ManufacturingBatch/getAllMO`,
        UPDATE_MANUFACTURING_ORDERS: `${URL.API_BASE_URL}/ManufacturingBatch/update`,
        GET_MANUFACTURING_ORDERS_BYID: `${URL.API_BASE_URL}/ManufacturingBatch/getMOById`,
        GET_MANUFACTURING_ORDERS_LINE_ITEMS: `${URL.API_BASE_URL}/ManufacturingBatch/getMOlineitem`,
        DELETEMO: `${URL.API_BASE_URL}/ManufacturingBatch/deleteMO`,
        // DELETEMOLINEITEM:`${URL.API_BASE_URL}/ManufacturingBatch/deletelineitem`,


        // Project Manufacturing Orders api's
        GETALLPMO: `${URL.API_BASE_URL}/ProjectManufacturingBatch/getAllPMO`,
        CREATEPMO: `${URL.API_BASE_URL}/ProjectManufacturingBatch/createPMO`,
        GETMBOM: `${URL.API_BASE_URL}/ProjectManufacturingBatch/getMBOM`,
        CREATEMBOM: `${URL.API_BASE_URL}/ProjectManufacturingBatch/createMBOM`,
        CREATEMBOMLINE: `${URL.API_BASE_URL}/ProjectManufacturingBatch/createMBOMlineitem`,
        GET_PROJECT_MANUFACTURING_ORDERS_BYID: `${URL.API_BASE_URL}/ProjectManufacturingBatch/getPMOById`,
        UPDATE_PROJECT_MANUFACTURING_ORDERS: `${URL.API_BASE_URL}/ProjectManufacturingBatch/updatePMO`,
        DELETEPMO: `${URL.API_BASE_URL}/ProjectManufacturingBatch/deletePMO`,
        GETMBOMLINE: `${URL.API_BASE_URL}/ProjectManufacturingBatch/getMBOMLineitem`,
        CHECK_MANUFACTURINGORDER_NUMBER: `${URL.API_BASE_URL}/ProjectManufacturingBatch/checkManufacturingBatchNumber`,
        AUTOSEARCHFINISHGOODS: `${URL.API_BASE_URL}/ProjectManufacturingBatch/`,
        // AUTOGENERATE_MANUFACTURINGBATCH_NUMBER: `${URL.API_BASE_URL}/Autogenerate/ManufacturingBatch`,
        AUTOGENERATE_MANUFACTURINGBATCH_NUMBER: `${URL.API_BASE_URL}/ProjectManufacturingBatch/generateManufacturingBatchNumber`,
        UPDATEPBOMLINEITEM: `${URL.API_BASE_URL}/ProjectManufacturingBatch/updatePMOlineitem`,

        //Product Requisition
        CREATEPRODUCTREQUISITION: `${URL.API_BASE_URL}/ProductRequisition/createproductrequisition`,
        GET_PRODUCTREQUISITION: `${URL.API_BASE_URL}/ProductRequisition/getproductrequisition`,
        GET_PRODUCTREQUISITIONBYID: `${URL.API_BASE_URL}/ProductRequisition/getproductrequisitionid`,
        UPDATE_PRODUCTREQUISITION: `${URL.API_BASE_URL}/ProductRequisition/updateproductrequisition`,
        DELETE_PRODUCTREQUISITION: `${URL.API_BASE_URL}/ProductRequisition/deleteproductrequisition`,
        SEARCH_PRODUCTREQUISITION: `${URL.API_BASE_URL}/ProductRequisition/searchproductrequisition`,
        GET_PURCHASEORDERBYID: `${URL.API_BASE_URL}/ProductRequisition/IsPOCreated`,

        CHECK_PRODUCTREQUISITION_NO: `${URL.API_BASE_URL}/ProductRequisition/checkProductRequisitionOrderNumber`,
        // AUTOGENERATE_PRODUCTREQUISITIONNUMBER: `${URL.API_BASE_URL}/Autogenerate/ProductRequisition`,
        AUTOGENERATE_PRODUCTREQUISITIONNUMBER: `${URL.API_BASE_URL}/ProductRequisition/generateProductRequisitionNumber`,
        UPDATE_PRODUCTREQUISITION_STATUS: `${URL.API_BASE_URL}/ProductRequisition/updatePRStatus`,

        //Product Requisition LineItem
        CREATEPRODUCTREQUISITION_LINEITEM: `${URL.API_BASE_URL}/ProductRequisition/createproductrequisitionlineitem`,
        GET_PRODUCTREQUISITION_LINEITEM: `${URL.API_BASE_URL}/ProductRequisition/getproductrequisitionlineitem`,
        GET_PRODUCTREQUISITION_BYID_LINEITEM: `${URL.API_BASE_URL}/ProductRequisition/getproductrequisitionlineitemById`,
        UPDATE_PRODUCTREQUISITION_LINEITEM: `${URL.API_BASE_URL}/ProductRequisition/updateproductrequisitionlineitem`,
        DELETE_PRODUCTREQUISITION_LINEITEM: `${URL.API_BASE_URL}/ProductRequisition/deleteproductrequisitionlineitem`,
        // UPDATE_PURCHASEORDER_STATUS: `${URL.API_BASE_URL}/Purchaseorder/updatePOStatus`,

        //CHECK_PRODUCTREQUISITION_NO: `${URL.API_BASE_URL}/ProductRequisition/checkProductRequisitionOrderNumber`,
        GETTPONUMBERBYID: `${URL.API_BASE_URL}/PurchaseOrder/getPurchaseOrderByPONumber`,

    },
    ACCOUNT: {
        GETALLACCOUNT: `${URL.API_BASE_URL}/Account/GetAccounts`,
        GETALLACTIVEACCOUNT: `${URL.API_BASE_URL}/Account/GetAllActiveAccounts`,
        GETACCOUNT: `${URL.API_BASE_URL}/Account/getAccountById`,
        CREATEACCOUNT: `${URL.API_BASE_URL}/Account/Create`,
        UPDATEACCOUNT: `${URL.API_BASE_URL}/Account/update`,
        DELETEACCOUNT: `${URL.API_BASE_URL}/Account/delete`,
        AUTOSEARCHACCOUNT: `${URL.API_BASE_URL}/Account/searchAccount`,
        SEARCHACCOUNT: `${URL.API_BASE_URL}/Account/searchAccounts`,

        GETALLACCOUNTTYPE: `${URL.API_BASE_URL}/Account/GetAccountstypes`,
        GETACCOUNTGROUPTYPE: `${URL.API_BASE_URL}/Account/GetAccountsGroupTypeById`,
        GETACCOUNTTYPE: `${URL.API_BASE_URL}/Account/GetAccountsTypesById`,
        CREATEACCOUNTTYPE: `${URL.API_BASE_URL}/Account/CreateAccountsType`,
        UPDATEACCOUNTTYPE: `${URL.API_BASE_URL}/Account/UpdateAccountType`,
        DELETEACCOUNTTYPE: `${URL.API_BASE_URL}/Account/DeleteAccountType`,

        GETALLACCOUNTGROUP: `${URL.API_BASE_URL}/Account/GetAccountGroup`,
        GETACCOUNTGROUP: `${URL.API_BASE_URL}/Account/GetAccountsGroupById`,
        CREATEACCOUNTGROUP: `${URL.API_BASE_URL}/Account/CreateAccountGroup`,
        UPDATEACCOUNTGROUP: `${URL.API_BASE_URL}/Account/UpdateAccountGroup`,
        DELETEACCOUNTGROUP: `${URL.API_BASE_URL}/Account/DeleteAccountGroup`,

        AUTOGENERATE_ACCOUNTGROUPCODE: `${URL.API_BASE_URL}/Account/AutogenerateAccountGroupTypeCode`,
        AUTOGENERATE_ACCOUNTCODE: `${URL.API_BASE_URL}/Account/AutogenerateAccountCode`,
        CHECK_ACCOUNTGROUP_CODE: `${URL.API_BASE_URL}/Account/checkAccountGroupCode`,
        CHECK_ACCOUNT_CODE: `${URL.API_BASE_URL}/Account/checkAccountCode`,
        CHECK_ACCOUNTTYPE_CODE: `${URL.API_BASE_URL}/Account/checkAccountTypeCode`,
        AUTOGENERATE_ACCOUNTTYPECODE: `${URL.API_BASE_URL}/Account/AutogenerateAccountTypeCode`,
        AUTOGENERATE_ACCOUNTSUBGROUPCODE: `${URL.API_BASE_URL}/Account/AutogenerateAccountSubGroupTypeCode`,
        CHECK_ACCOUNTSUBGROUP_CODE: `${URL.API_BASE_URL}/Account/checkAccountSubGroupCode`,
        CREATEACCOUNTSUBGROUP: `${URL.API_BASE_URL}/Account/CreateAccountsSubGroup`,
        GETALLACCOUNTSUBGROUP: `${URL.API_BASE_URL}/Account/GetAccountSubGroupType`,
        GETACCOUNTSUBGROUPTYPE: `${URL.API_BASE_URL}/Account/GetAccountsSubGroupTypeById`,
        GETACCOUNTBYCODE: `${URL.API_BASE_URL}/Account/GetAccountByCode`,
        GET_ACCOUNT_BALANCE: `${URL.API_BASE_URL}/Account/GetAccountBalance`,
        GET_ACCOUNT_LEDGER: `${URL.API_BASE_URL}/Account/GetAccountLedger`,
        RECALCULATE_GL_BALANCES: `${URL.API_BASE_URL}/Account/RecalculateGlBalances`,

        //GL DEFAULT
        SAVEDEFAULTGL: `${URL.API_BASE_URL}/Account/createGLDefault`,
        GET_GLDEFAULTS_BY_WAREHOUSE: `${URL.API_BASE_URL}/Account/getGLDefaultsByWarehouse`,
        SAVEUPDATEDEFAULTGL: `${URL.API_BASE_URL}/Account/saveOrUpdateGLDefaults`,
        GET_ACCOUNTTYPE_LIST: `${URL.API_BASE_URL}/Account/GetAccountTypes`,
        GET_ACCOUNTS: `${URL.API_BASE_URL}/Account/GetAccounts`,
    },
    BANK: {
        GETALLBANK: `${URL.API_BASE_URL}/Bank/getBank`,
        GETBANK: `${URL.API_BASE_URL}/Bank/getBankById`,
        CREATEBANK: `${URL.API_BASE_URL}/Bank/create`,
        AUTOGENERATE_BANKCODE: `${URL.API_BASE_URL}/Autogenerate/Bank`,
        CHECK_BANK_CODE: `${URL.API_BASE_URL}/Bank/checkBankCode`,
        CHECK_BANK_NAME: `${URL.API_BASE_URL}/Bank/checkBankName`,

        DELETEBANK: `${URL.API_BASE_URL}/Bank/delete`,
        UPDATEBANK: `${URL.API_BASE_URL}/Bank/update`,
        GETALLCURRENCY: `${URL.API_BASE_URL}/Currency/GetCurrency`,
        AUTOSEARCHBANK: `${URL.API_BASE_URL}/Bank/searchBank`,
    },
    REPORTCENTER: {
        GET_REPORTLIST: `${URL.API_BASE_URL}/ReportCenter/getReportList`,
        CREATE_REPORT: `${URL.API_BASE_URL}/ReportCenter/create`,
        AUTOSEARCHREPORT: `${URL.API_BASE_URL}/ReportCenter/search`,
        GETREPORTBYNAME: `${URL.API_BASE_URL}/Forms/getFormByCode`,
        GETREPORT: `${URL.API_BASE_URL}/ReportCenter/getReportsByGroup`,
        GETREPORTGROUP: `${URL.API_BASE_URL}/ReportCenter/getGroupNames`,

    },
    DASHBOARD: {
        GET_SALESAMOUNTPERMONTH: `${URL.API_BASE_URL}/Dashboard/getSalesAmountPerMonth`,
        GET_HOMEDASHBOARDDATA: `${URL.API_BASE_URL}/Dashboard/getHomeDashboardData`,
        GET_TOPSELLINGPRODUCTS: `${URL.API_BASE_URL}/Dashboard/getTopSellingProducts`,
        GET_RECENTSALES: `${URL.API_BASE_URL}/Dashboard/getRecentSales`,
        GET_ORDERSTATISTICS: `${URL.API_BASE_URL}/Dashboard/getOrderStatistics`,
        GET_POSTATISTICS: `${URL.API_BASE_URL}/Dashboard/getPOStatistics`,
        GET_OPENPO_TRANSACTION: `${URL.API_BASE_URL}/Dashboard/getOpenPOTransaction`,
        GET_PENDING_SHIPMENT_TRANSACTION: `${URL.API_BASE_URL}/Dashboard/getPendingShipmentTransaction`,
        GET_TOP_SALES_TRANSACTION: `${URL.API_BASE_URL}/Dashboard/getTopSalesTransactions`,
        GET_TOP_PORECEIPT_TRANSACTION: `${URL.API_BASE_URL}/Dashboard/getTopPOReceiptTransactions`,
        GET_INVENTORY_VALUE_BY_WAREHOUSE: `${URL.API_BASE_URL}/Dashboard/getInventoryValueByWarehouse`,
        GET_PROJECTDASHBOARDDATA: `${URL.API_BASE_URL}/Dashboard/GetProjectDashboardData`,
        GET_RECENTPO: `${URL.API_BASE_URL}/Dashboard/getRecentPurchaseOrders`,
        GET_ACCOUNT_RECEIVABLE_AND_PAYABLE: `${URL.API_BASE_URL}/AccountingDashboard/accounting-dashboard`,
        GET_INCOME_EXPENSE_CHART: `${URL.API_BASE_URL}/AccountingDashboard/income-expense-chart`,
        GET_TOP_EXPENSES: `${URL.API_BASE_URL}/AccountingDashboard/top-expenses`,
        GET_CASH_FLOW_CHART: `${URL.API_BASE_URL}/AccountingDashboard/cashflow`,
        GET_TOP_RECEIVABLES: `${URL.API_BASE_URL}/AccountingDashboard/top-receivables`,
        GET_TOP_PAYABLES: `${URL.API_BASE_URL}/AccountingDashboard/top-payables`,
        GET_SALES_DASHBOARD_DATA: `${URL.API_BASE_URL}/Dashboard/getSalesDashboardData`,
        INVENTORY_STOCK_DISTRIBUTION: `${URL.API_BASE_URL}/AccountingDashboard/inventory-stock-distribution`,

    },

    PROJECTDASHBOARD: {
        GET_MY_TASK: `${URL.API_BASE_URL}/Dashboard/GetMyTask`,
        GET_MY_PHASES: `${URL.API_BASE_URL}/Dashboard/GetMyPhases`,
    },

    DELIVERYCHALLAN: {
        GET_DELIVERY_CHALLAN: `${URL.API_BASE_URL}/DeliveryChallan/getDeliveryChallan`,
        GET_DELIVERY_CHALLAN_BYID: `${URL.API_BASE_URL}/DeliveryChallan/GetDeliveryChallanById`,
        CREATE_DELIVERY_CHALLAN: `${URL.API_BASE_URL}/DeliveryChallan/createDeliveryChallan`,
        UPDATE_DELIVERY_CHALLAN: `${URL.API_BASE_URL}/DeliveryChallan/updateDeliveryChallan`,
        DELETE_DELIVERY_CHALLAN: `${URL.API_BASE_URL}/DeliveryChallan/delete`,
        SEARCH_DELIVERY_CHALLAN: `${URL.API_BASE_URL}/DeliveryChallan`,
        CHECK_DC_NO: `${URL.API_BASE_URL}/DeliveryChallan/checkDCNumber`,

        GET_DC_LINEITEM_BYDCNO: `${URL.API_BASE_URL}/DeliveryChallan/getDCLineItemByDCNo`,
        CREATE_DC_LINEITEM: `${URL.API_BASE_URL}/DeliveryChallan/createDCOrderLine`,
        UPDATE_DC_LINEITEM: `${URL.API_BASE_URL}/DeliveryChallan/updateDCOrderLine`,
        DELETE_DC_LINEITEM: `${URL.API_BASE_URL}/DeliveryChallan/deleteDCOrderLine`,
        AUTOGENERATE_DCNUMBER: `${URL.API_BASE_URL}/Autogenerate/DeliveryChallan`,
    },

    PAYMENTRECEIPT: {
        //AUTOGENERATE_PAYMENTRECEIPTNO: `${URL.API_BASE_URL}/Autogenerate/PaymentReceipt`,
        AUTOGENERATE_PAYMENTRECEIPTNO: `${URL.API_BASE_URL}/PaymentReceipt/generatePaymentReceiptNumber`,
        GET_PAYMENT_TYPES: `${URL.API_BASE_URL}/PaymentReceipt/getPaymentTypes`,
        GET_CREDIT_CARD_TYPES: `${URL.API_BASE_URL}/PaymentReceipt/getCreditCardTypes`,
        CHECK_PAY_RECEIPT_NO: `${URL.API_BASE_URL}/PaymentReceipt/checkPaymentReceiptNo`,
        GET_OPENINVOICE_BY_CUSTOMERCODE: `${URL.API_BASE_URL}/PaymentReceipt/getARByCustomer`,
        //GET_OPENINVOICE_BY_CUSTOMERCODE: `${URL.API_BASE_URL}/PaymentReceipt/GetAccountReceivableByCustomerInvoiceBill`,
        CREATE_PAYMENTRECEIPT: `${URL.API_BASE_URL}/PaymentReceipt/createPaymentReceipt`,
        CREATE_PAYMENTRECEIPT_LINEITEM: `${URL.API_BASE_URL}/PaymentReceipt/createPaymentReceiptLineItem`,

        GET_PAYMENTRECEIPT_LIST: `${URL.API_BASE_URL}/PaymentReceipt/getPaymentReceiptList`,
        GET_PAYMENTRECEIPT_BY_ID: `${URL.API_BASE_URL}/PaymentReceipt/GetPaymentReceiptById`,
        GET_PAYMENTRECEIPT_LINEITEM_BY_PRNO: `${URL.API_BASE_URL}/PaymentReceipt/getPRLineItemByPRNo`,
        GET_PAYMENTRECEIPT_LINEITEM_BY_ID: `${URL.API_BASE_URL}/PaymentReceipt/getPRLineItemsByPaymentReceiptId`,
        GET_PAYMENTRECEIPT_BY_INVOICENO: `${URL.API_BASE_URL}/PaymentReceipt/getPaymentReceiptByInvoiceNo`,
        GET_PAYMENT_COLLECTIONS: `${URL.API_BASE_URL}/PaymentReceipt/getPaymentCollectionByCustomer`,
        SEARCH_PAYMENT_RECEIPT: `${URL.API_BASE_URL}/PaymentReceipt/search`,
        GET_BANKS: `${URL.API_BASE_URL}/PaymentReceipt/getBank`,

        CREATE_PAYMENTRECEIPT_LINEITEMS: `${URL.API_BASE_URL}/PaymentReceipt/createPaymentReceiptLineItems`,
        UPDATE_PAYMENTRECEIPT: `${URL.API_BASE_URL}/PaymentReceipt/updatePaymentReceipt`,
        UPDATE_PAYMENTRECEIPT_STATUS: `${URL.API_BASE_URL}/PaymentReceipt/UpdatePaymentReceiptStatus`,
        GET_ADVANCE_CUSTOMER_PAYMENTS: `${URL.API_BASE_URL}/PaymentReceipt/getAdvanceCustomerPayments`,
        APPLY_CUSTOMER_CREDITS: `${URL.API_BASE_URL}/PaymentReceipt/applyCustomerCredits`,
        GET_APPLIED_CUSTOMER_CREDITS: `${URL.API_BASE_URL}/PaymentReceipt/getAppliedCustomerCreditsByInvoice`,
        GET_UNPROCESSED_PAYMENT_SUM: `${URL.API_BASE_URL}/PaymentReceipt/getUnprocessedPaymentSum`,
        GET_UNPROCESSED_PAYMENT_SUMS_BY_CUSTOMER: `${URL.API_BASE_URL}/PaymentReceipt/getUnprocessedPaymentSumsByCustomer`,
        VOID_PAYMENT_RECEIPT: `${URL.API_BASE_URL}/PaymentReceipt/voidPaymentReceipt`,
        GL_POST_PAYMENT_RECEIPT: `${URL.API_BASE_URL}/GLPosting/PaymentReceipt`,
        GL_ENTRIES_PAYMENT_RECEIPT: `${URL.API_BASE_URL}/GLPosting/Entries/PaymentReceipt`,
    },

    // Store Consumption Endpoints

    STORECONSUMPTION:
    {
        CHECK_STORECONSUMPTION_NUMBER: `${URL.API_BASE_URL}/StoreConsumption/checkSCNumber`,
        GET_ALLSTORECONSUMPTION: `${URL.API_BASE_URL}/StoreConsumption/getAllStoreConsumption`,
        GET_ALLSTORECONSUMPTIONBYID: `${URL.API_BASE_URL}/StoreConsumption/getStoreConsumptionById`,
        GET_ALLSTORECONSUMPTIONBYPMOID: `${URL.API_BASE_URL}/StoreConsumption/getStoreConsumptionByPMOId`,
        CREATE_STORECONSUMPTION: `${URL.API_BASE_URL}/StoreConsumption/create`,
        AUTOGENERATE_SCNUMBER: `${URL.API_BASE_URL}/StoreConsumption/AutogenerateStoreConsumption`,
        UPDATE_STORECONSUMPTION: `${URL.API_BASE_URL}/StoreConsumption/update`,
        DELETE_STORECONSUMPTION: `${URL.API_BASE_URL}/StoreConsumption/deleteStoreConsumption`,
        // AUTOGENERATE_SERIALNUMBER: `${URL.API_BASE_URL}/Autogenerate/StoreConsumption`,
        AUTOGENERATE_SERIALNUMBER: `${URL.API_BASE_URL}/StoreConsumption/generateStoreConsumptionNumber`,
        SEARCHSP: `${URL.API_BASE_URL}/StoreConsumption/searchStoreConsumption`,

        // Store consumption lineitems

        CREATE_STORECONSUMPTIONLINEITEM: `${URL.API_BASE_URL}/StoreConsumption/createscLineitem`,
        GET_ALLSTORECONSUMPTIONLINEITEMBYSCID: `${URL.API_BASE_URL}/StoreConsumption/getStoreConsumptionByScId`,
        UPDATE_STORECONSUMPTIONLINEITEM: `${URL.API_BASE_URL}/StoreConsumption/updateLineitem`,
        AUTOGENERATE_SERIALNUMBERSCL: `${URL.API_BASE_URL}/Autogenerate/StoreConsumptionLineItem`,
        //AUTOGENERATE_SERIALNUMBERSCL: `${URL.API_BASE_URL}/StoreConsumption/generateSerial`,
        DELETE_STORECONSUMPTIONSCL: `${URL.API_BASE_URL}/StoreConsumption/deleteStoreConsumptionLineitem`
    },
    CRM: {
        AUTOGENERATE_DEAL_CODE: `${URL.API_BASE_URL}/CRM/generateDealCode`,
        AUTOGENERATE_TASK_CODE: `${URL.API_BASE_URL}/CRM/generateTaskCode`,
        AUTOGENERATE_LEAD_CODE: `${URL.API_BASE_URL}/CRM/generateLeadCode`,
        AUTOGENERATE_SERVICEINVOICE: `${URL.API_BASE_URL}/Autogenerate/ServiceCall`,
        GET_CRM_CONTACT: `${URL.API_BASE_URL}/Contact/getCRMContacts`,
        GET_DEAL_LIST: `${URL.API_BASE_URL}/CRM/getDeal`,
        GET_TASK_LIST: `${URL.API_BASE_URL}/CRM/getTask`,
        GET_LEAD_LIST: `${URL.API_BASE_URL}/CRM/getLead`,
        GET_LEAD_LIST_BY_STATUS: `${URL.API_BASE_URL}/CRM/getLeadByStatus`,
        CREATE_DEAL: `${URL.API_BASE_URL}/CRM/createDeal`,
        CREATE_TASK: `${URL.API_BASE_URL}/CRM/createTask`,
        CREATE_LEAD: `${URL.API_BASE_URL}/CRM/createLead`,
        UPDATE_DEAL: `${URL.API_BASE_URL}/CRM/updateDeal`,
        UPDATE_TASK: `${URL.API_BASE_URL}/CRM/updateTask`,
        UPDATESTATUS: `${URL.API_BASE_URL}/CRM/updatestatus`,
        UPDATE_LEAD: `${URL.API_BASE_URL}/CRM/updateLead`,
        DELETE_DEAL: `${URL.API_BASE_URL}/CRM/deleteDeal`,
        DELETE_TASK: `${URL.API_BASE_URL}/CRM/deleteTask`,
        DELETE_LEAD: `${URL.API_BASE_URL}/CRM/deleteLead`,
        GET_DEAL_BY_ID: `${URL.API_BASE_URL}/CRM/getDealById`,
        GET_TASK_BY_ID: `${URL.API_BASE_URL}/CRM/getTaskById`,
        GET_LEAD_BY_ID: `${URL.API_BASE_URL}/CRM/getLeadById`,
        CHECK_DEAL_CODE: `${URL.API_BASE_URL}/CRM/checkDealCode`,
        CHECK_TASK_CODE: `${URL.API_BASE_URL}/CRM/checkTaskCode`,
        CHECK_LEAD_CODE: `${URL.API_BASE_URL}/CRM/checkLeadCode`,
        GET_TASK_LIST_BY_REMINDER: `${URL.API_BASE_URL}/CRM/getTaskListByReminder`,
        SEARCH_DEAL: `${URL.API_BASE_URL}/CRM/searchDeal`,
        SEARCH_TASK: `${URL.API_BASE_URL}/CRM/searchTask`,
        SEARCH_LEAD: `${URL.API_BASE_URL}/CRM/searchLead`,
        SEARCH_SERVICECALL: `${URL.API_BASE_URL}/CRM/searchServiceCall`,
        GETTASKBYCODE: `${URL.API_BASE_URL}/CRM/getTaskByCode`,

        //Lead Comment
        ADD_LEAD_COMMENT: `${URL.API_BASE_URL}/LeadComment/addLeadComment`,
        UPDATE_LEAD_COMMENT: `${URL.API_BASE_URL}/LeadComment/updateLeadComment`,
        DELETE_LEAD_COMMENT: `${URL.API_BASE_URL}/LeadComment/deleteLeadComment`,
        GET_LEAD_COMMENTS_BYLeadCode: `${URL.API_BASE_URL}/LeadComment/getLeadCommentsByLeadCode`,
        GET_LEAD_COMMENTS_BYLeadID: `${URL.API_BASE_URL}/LeadComment/getLeadCommentsByLeadId`,

        //Deal Comment
        ADD_DEAL_COMMENT: `${URL.API_BASE_URL}/DealComment/addDealComment`,
        UPDATE_DEAL_COMMENT: `${URL.API_BASE_URL}/DealComment/updateDealComment`,
        DELETE_DEAL_COMMENT: `${URL.API_BASE_URL}/DealComment/deleteDealComment`,
        GET_DEAL_COMMENTS_BYDealCode: `${URL.API_BASE_URL}/DealComment/getDealCommentsByDealCode`,
        GET_DEAL_COMMENTS_BYDealID: `${URL.API_BASE_URL}/DealComment/getDealCommentsByDealId`,

        //Tasks Comment
        ADD_Task_COMMENT: `${URL.API_BASE_URL}/TasksComment/addTaskComment`,
        UPDATE_Task_COMMENT: `${URL.API_BASE_URL}/TasksComment/updateTaskComment`,
        DELETE_Task_COMMENT: `${URL.API_BASE_URL}/TasksComment/deleteTaskComment`,
        GET_Task_COMMENTS_BYTaskCode: `${URL.API_BASE_URL}/TasksComment/getTaskCommentsByTaskCode`,
        GET_Task_COMMENTS_BYTaskID: `${URL.API_BASE_URL}/TasksComment/getTaskCommentsByTaskId`,
    },
    SERVICECALL: {
        //AUTOGENERATE_SERVICE_CODE: `${URL.API_BASE_URL}/Autogenerate/ServiceCall`,
        AUTOGENERATE_SERVICE_CODE: `${URL.API_BASE_URL}/ServiceCall/generateServiceCallNumber`,
        CREATE: `${URL.API_BASE_URL}/ServiceCall/createServiceCall`,
        UPDATE: `${URL.API_BASE_URL}/ServiceCall/updateServiceCall`,
        GET_SERVICE_CALL_LIST: `${URL.API_BASE_URL}/ServiceCall/getServiceCall`,
        GET_SERVICE_CALL_BY_ID: `${URL.API_BASE_URL}/ServiceCall/getServiceCallId`,
        DELETE_SERVICE_CALL: `${URL.API_BASE_URL}/ServiceCall/deleteServiceCall`,
        CHECK_SERVICE_CALL_CODE: `${URL.API_BASE_URL}/ServiceCall/checkServiceCallCode`,
        GET_SERVICE_CALL_BY_APPOINTMENT: `${URL.API_BASE_URL}/CRM/getServiceCallByAppointment`,
        GET_ALLEMPLOYEE: `${URL.API_BASE_URL}/ServiceCall/getAllEmployee`,
    },
    POINTOFSALE: {
        AUTOGENERATE_TRANS_CODE: `${URL.API_BASE_URL}/Autogenerate/PointofSale`,
        SAVE_TRANSACTION: `${URL.API_BASE_URL}/PointOfSales/CreateTransaction`,
        GET_TRANSACTIONS: `${URL.API_BASE_URL}/PointOfSales/getTransactions`,
        GET_TRANSACTION_BY_ID: `${URL.API_BASE_URL}/PointOfSales/GetTransactionById`,
        DELETE_POS: `${URL.API_BASE_URL}/PointOfSales/deleteTransaction`,

    },

    SYSTEMCONFIGURATION: {
        GET_SYSTEMCONFIG: `${URL.API_BASE_URL}/SystemConfig/getAllSystemConfig`,
        UPDATE_STEMCONFIG: `${URL.API_BASE_URL}/SystemConfig/updateSystemConfigData`,
        AUTOSEARCHSTEMCONFIG: `${URL.API_BASE_URL}/SystemConfig/searchSystemConfigData`,
        GET_STEMCONFIGBYID: `${URL.API_BASE_URL}/SystemConfig/getAllSystemConfigById`,
        GET_STEMCONFIG_BY_APPKEY: `${URL.API_BASE_URL}/SystemConfig/getSystemConfigByAppKey`
    },

    PROJECTBUDGET: {
        GETALLPROJECTBUDGET: `${URL.API_BASE_URL}/ProjectBOM/getAllProjectBudget`,
        CREATEPROJECTBUDGET: `${URL.API_BASE_URL}/ProjectBOM/createProjectBudget`,
        GET_PROJECTBUDGETBYID: `${URL.API_BASE_URL}/ProjectBOM/getProjectBudgetById`,
        UPDATE_PROJECTBUDGET: `${URL.API_BASE_URL}/ProjectBOM/updateProjectBudgets`,
        PROJECTBUDGET: `${URL.API_BASE_URL}/ProjectBOM/deleteProjectBudgets`,
        AUTOSEARCHSALESORDERNUMBER: `${URL.API_BASE_URL}/SalesOrder/SearchSalesOrderNumberByCode`,

    },

    // Bill of Materilas for Sparsh  03-06-2025

    BILLOFMATERIAL: {

        CREATEBOM: `${URL.API_BASE_URL}/Billofmaterial/createBOM`,
        GETALLBOM: `${URL.API_BASE_URL}/Billofmaterial/getAllBillOfMaterilas`,
        GETBOM: `${URL.API_BASE_URL}/Billofmaterial/getBillOfMaterialById`,
        UPDATEBOM: `${URL.API_BASE_URL}/Billofmaterial/updateBillOfMaterial`,
        DELETEBOM: `${URL.API_BASE_URL}/Billofmaterial/deleteBillOfMaterial`,
        AUTOSEARCHBOM: `${URL.API_BASE_URL}/Billofmaterial/searchBillOfMaterial`,




        CREATEBOMLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/createBomlineitem`,
        GETBOMLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/getBillOfMateriallineitem`,
        UPDATEBOMLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/updateBOMlineitem`,
        DELETEBILLOFMATERIALLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/deleteBOMlineitem`,
        AUTOSEARCHBOMLINEITEM: `${URL.API_BASE_URL}/Billofmaterial/searchBillOfMaterialLineItem`,

        GETBILLOFMATERIALLINEITEMSPARSH: `${URL.API_BASE_URL}/Billofmaterial/getBOMlineitemForSparsh`,
        AUTOSEARCHBOMS: `${URL.API_BASE_URL}/ProjectManufacturingBatch/searchBillOfMaterials`,

    },
    // Purchase Order Return

    PURCHASEORDERRETURN: {
        CREATE_PO_RETURN: `${URL.API_BASE_URL}/Purchaseorder/createPOReturn`,
        GET_PO_RETURN: `${URL.API_BASE_URL}/Purchaseorder/getPOReturn`,
        GET_PURCHASEORDERRETURN_BYID: `${URL.API_BASE_URL}/Purchaseorder/getPOReturnById`,
        DELETE_PURCHASEORDER_RETURN: `${URL.API_BASE_URL}/Purchaseorder/deletePOReturn`,
        UPDATE_PURCHASEORDER_RETURN: `${URL.API_BASE_URL}/Purchaseorder/updatePOReturn`,
        CREATE_PO_RETURN_LINEITEM: `${URL.API_BASE_URL}/Purchaseorder/createPOReturnLineItem`,
        GET_PO_RETURN_LINEITEM_BYID: `${URL.API_BASE_URL}/Purchaseorder/getPOReturnLineItemById`,
        UPDATE_PURCHASEORDER_RETURN_LINEITEM: `${URL.API_BASE_URL}/Purchaseorder/updatePOReturnLineItem`,
        DELETE_PURCHASEORDER_RETURN_LINEITEM: `${URL.API_BASE_URL}/Purchaseorder/DeletePOReturnLineItem`,
        AUTOSEARCHRETURNPO: `${URL.API_BASE_URL}/Purchaseorder/searchPORetuen`,

    },

    // RFQ APIs's

    RFQ: {
        CHECK_RFQ_CODE: `${URL.API_BASE_URL}/RFQ/checkRfqNumber`,
        // AUTOGENERATE_RFQCODE: `${URL.API_BASE_URL}/Autogenerate/RFQ`,
        AUTOGENERATE_RFQCODE: `${URL.API_BASE_URL}/RFQ/generateRfqNumber`,
        CREATE_RFQ: `${URL.API_BASE_URL}/RFQ/createRFQ`,
        RFQ_LIST: `${URL.API_BASE_URL}/RFQ/getRFQs`,
        UPDATE_RFQ: `${URL.API_BASE_URL}/RFQ/updateRFQ`,
        DELETE_RFQ: `${URL.API_BASE_URL}/RFQ/delete`,
        GET_RFQ_BY_ID: `${URL.API_BASE_URL}/RFQ/getRFQById`,
        CREATE_RFQ_VENDORS: `${URL.API_BASE_URL}/RFQ/createRFQVendors`,
        CREATE_RFQ_PRODUCTS: `${URL.API_BASE_URL}/RFQ/createRFQProducts`,
        UPDATE_RFQ_VENDORS: `${URL.API_BASE_URL}/RFQ/updateRFQVendors`,
        UPDATE_RFQ_PRODUCTS: `${URL.API_BASE_URL}/RFQ/updateRFQProducts`,
        DELETE_RFQ_VENDOR: `${URL.API_BASE_URL}/RFQ/deleteRFQVendor`,
        DELETE_RFQ_PRODUCT: `${URL.API_BASE_URL}/RFQ/deleteRFQProduct`,
        SEARCHRFQ: `${URL.API_BASE_URL}/RFQ/searchRfq`

    },

    SYSTEM: {
        GET_UNITCONFIG_BY_APPKEY: `${URL.API_BASE_URL}/SystemConfig/getSystemConfigByAppKey`,
        GET_DEPTCONFIG_BY_APPKEY: `${URL.API_BASE_URL}/SystemConfig/getSystemConfigByAppKey`
    },

    // HRMS

    EMPLOYEE: {
        CREATE_EMPLOYEE: `${URL.API_BASE_URL}/HRMS/createEmployee`,
        GET_EMPLOYEE: `${URL.API_BASE_URL}/HRMS/getEmployees`,
        GET_EMPLOYEE_BYID: `${URL.API_BASE_URL}/HRMS/GetEmployeeById`,
        UPDATE_EMPLOYEE: `${URL.API_BASE_URL}/HRMS/updateEmployee`,
        DELETE_EMPLOYEE: `${URL.API_BASE_URL}/HRMS/deleteEmployee`,
        AUTOSEARCHEMPLOYEE: `${URL.API_BASE_URL}/HRMS/SearchEmployee`,

        // Employee Shift 

        CREATE_EMPLOYEE_SHIFT: `${URL.API_BASE_URL}/HRMS/createShift`,
        GET_SHIFT: `${URL.API_BASE_URL}/HRMS/getShift`,
        GET_SHIFT_BYID: `${URL.API_BASE_URL}/HRMS/GetShiftId`,
        UPDATE_SHIFT: `${URL.API_BASE_URL}/HRMS/updateEmployeeShift`,
        DELETE_SHIFT: `${URL.API_BASE_URL}/HRMS/deleteEmployeeShift`,
        AUTOSEARCHSHIFT: `${URL.API_BASE_URL}/HRMS/SearchEmployeeShift`,

        // Employee Attendance

        CREATE_EMPLOYEE_ATTENDANCE: `${URL.API_BASE_URL}/HRMS/createAttendance`,
        GET_EMPLOYEE_ATTENDANCE: `${URL.API_BASE_URL}/HRMS/getAttendance`,
        UPDATE_ATTENDANCE: `${URL.API_BASE_URL}/HRMS/updateAttendance`,
        GET_EMPLOYEE_ATTENDANCE_BYID: `${URL.API_BASE_URL}/HRMS/getAttendanceById`,


        // Employee leave
        CREATE_EMPLOYEE_LEAVE: `${URL.API_BASE_URL}/HRMS/createLeave`,
        GET_EMPLOYEE_LEAVE: `${URL.API_BASE_URL}/HRMS/getLeaves`,
        UPDATE_LEAVE: `${URL.API_BASE_URL}/HRMS/updateleave`,
        DELETE_LEAVE: `${URL.API_BASE_URL}/HRMS/deleteLeaves`,
        AUTOSEARCHLEAVE: `${URL.API_BASE_URL}/HRMS/Searchleaves`,
        GET_LEAVE_BYID: `${URL.API_BASE_URL}/HRMS/getLeavesId`,
        GET_LEAVE_SUMMURY: `${URL.API_BASE_URL}/HRMS/getleaveSummary`,
        SEND_MAIL: `${URL.API_BASE_URL}/Mail/ApplyLeaveRequest`,
        REVIEWED_LEAVE_REQUEST: `${URL.API_BASE_URL}/Mail/ReviewedLeaveRequest`,
        GET_LEAVE_BALANCE: `${URL.API_BASE_URL}/HRMS/getLeavesBalance`,
        // Employee Designation
        GET_EMPLOYEE_DESIGNATION: `${URL.API_BASE_URL}/HRMS/getDesignation`,
        // get leave types
        GET_LEAVE_TYPES: `${URL.API_BASE_URL}/HRMS/getLeaveTypes`,
        // get leave reasons
        GET_LEAVE_REASONS: `${URL.API_BASE_URL}/HRMS/getLeaveReasons`,
        CREATE_LOCATION: `${URL.API_BASE_URL}/HRMS/createLocation`,
        GET_LOCATION: `${URL.API_BASE_URL}/HRMS/getLocation`,
        GET_LOCATION_BYID: `${URL.API_BASE_URL}/HRMS/GetLocationById`,
        UPDATE_LOCATION: `${URL.API_BASE_URL}/HRMS/updateLocation`,
        DELETE_LOCATION: `${URL.API_BASE_URL}/HRMS/deleteLocation`,
        ASSIGN_LOCATION_TO_EMPLOYEE: `${URL.API_BASE_URL}/HRMS/assignLocationToEmployee`,
        GET_EMPLOYEE_LOCATIONS: `${URL.API_BASE_URL}/HRMS/GetEmployeeLocations`,
        LOCATION_CHECKIN: `${URL.API_BASE_URL}/HRMS/checkIn`,
        LOCATION_CHECKOUT: `${URL.API_BASE_URL}/HRMS/checkOut`,
        GET_PENDING_APPROVALS: `${URL.API_BASE_URL}/HRMS/getPendingApprovals`,
        APPROVE_ATTENDANCE: `${URL.API_BASE_URL}/HRMS/approveAttendance`,
        AUTOSEARCHLOCATION: `${URL.API_BASE_URL}/HRMS/SearchLocation`,

        //offboarding
        CREATE_OFFBOARDING: `${URL.API_BASE_URL}/HRMS/CreateOffboarding`,
        GET_OFFBOARDING: `${URL.API_BASE_URL}/HRMS/GetOffboarding`,
        GET_OFFBOARDING_BY_ID: `${URL.API_BASE_URL}/HRMS/GetOffboardingById`,
        UPDATE_OFFBOARDING: `${URL.API_BASE_URL}/HRMS/UpdateOffboarding`,
        DELETE_OFFBOARDING: `${URL.API_BASE_URL}/HRMS/DeleteOffboarding`,
        SEARCH_OFFBOARDING: `${URL.API_BASE_URL}/HRMS/SearchOffboarding`,
        GET_ONBOARDING: `${URL.API_BASE_URL}/HRMS/GetOnboarding`,
        SEARCH_ONBOARDING: `${URL.API_BASE_URL}/HRMS/GetOnboarding`,
        GET_ALL_EMPLOYEES: `${URL.API_BASE_URL}/HRMS/GetAllEmployees`,

        // EXPENS
        CREATE_EXPENSE_REIMBURSEMENT: `${URL.API_BASE_URL}/HRMS/CreateExpenseReimbursement`,
        GET_EXPENSE_REIMBURSEMENT: `${URL.API_BASE_URL}/HRMS/GetExpenseReimbursement`,
        GET_EXPENSE_REIMBURSEMENT_BY_ID: `${URL.API_BASE_URL}/HRMS/GetExpenseReimbursementById`,
        UPDATE_EXPENSE_REIMBURSEMENT: `${URL.API_BASE_URL}/HRMS/UpdateExpenseReimbursement`,
        DELETE_EXPENSE_REIMBURSEMENT: `${URL.API_BASE_URL}/HRMS/DeleteExpenseReimbursement`,
        SEARCH_EXPENSE_REIMBURSEMENT: `${URL.API_BASE_URL}/HRMS/SearchExpenseReimbursement`,

        // Knowledge Transfer 
        SAVE_KNOWLEDGE_TRANSFER: `${URL.API_BASE_URL}/HRMS/SaveKnowledgeTransfer`,
        GET_KNOWLEDGE_TRANSFER: `${URL.API_BASE_URL}/HRMS/GetKnowledgeTransfer`,
        UPDATE_KNOWLEDGE_TRANSFER: `${URL.API_BASE_URL}/HRMS/SaveKnowledgeTransfer`,
        DELETE_KNOWLEDGE_TRANSFER: `${URL.API_BASE_URL}/HRMS/DeleteKnowledgeTransfer`,

        //  Exit Interview 
        SAVE_EXIT_INTERVIEW: `${URL.API_BASE_URL}/HRMS/SaveExitInterview`,
        GET_EXIT_INTERVIEW: `${URL.API_BASE_URL}/HRMS/GetExitInterview`,

        // Exitclosure
        SAVE_EXIT_CLOSURE: `${URL.API_BASE_URL}/HRMS/SaveExitClosure`,
        GET_EXIT_CLOSURE: `${URL.API_BASE_URL}/HRMS/GetExitClosure`,

    },


    //TDS
    TDSSECTION: {
        GET_SECTION: `${URL.API_BASE_URL}/TDS/getSection`,
        GET_PAYABLE_ACCOUNT: `${URL.API_BASE_URL}/TDS/getPayableAccount`,
        GET_RECEIVABLE_ACCOUNT: `${URL.API_BASE_URL}/TDS/getReceivableAccount`,
        GET_TAXES: `${URL.API_BASE_URL}/TDS/getTaxes`,
        DELETE_TAXES: `${URL.API_BASE_URL}/TDS/deleteTax`,
        CREATE_TAXES: `${URL.API_BASE_URL}/TDS/createTax`,
        UPDATE_TAXES: `${URL.API_BASE_URL}/TDS/updateTax`,
        GET_TAXES_BY_ID: `${URL.API_BASE_URL}/TDS/getTaxesById`,
        SEARCH_TAXES: `${URL.API_BASE_URL}/TDS/searchTax`,
        CHECK_TAXCODE: `${URL.API_BASE_URL}/TDS/checkTaxCode`,
    },
    MANALJOURNALS: {
        GETALLMANALJOURNALS: `${URL.API_BASE_URL}/ManualJournals/GetManualJournals`,
        GETMANALJOURNALS: `${URL.API_BASE_URL}/ManualJournals/GetManualJournalsById`,
        CREATEMANALJOURNALS: `${URL.API_BASE_URL}/ManualJournals/Create`,
        UPDATEMANALJOURNALS: `${URL.API_BASE_URL}/ManualJournals/update`,
        DELETEMANALJOURNALS: `${URL.API_BASE_URL}/ManualJournals/delete`,
        AUTOSEARCHMANALJOURNALS: `${URL.API_BASE_URL}/ManualJournals/searchManualJournals`,
        CREATEMANALJOURNALSLINEITEM: `${URL.API_BASE_URL}/ManualJournals/createManualJournalsLineItem`,
        GETMANALJOURNALSLINEITEMBYID: `${URL.API_BASE_URL}/ManualJournals/GetManualJournalsLineItemsByJournalId`,
        DELETEMANALJOURNALSLINEITEM: `${URL.API_BASE_URL}/ManualJournals/deleteManualJournalsLineItems`,
        UPDATEMANALJOURNALSLINEITEM: `${URL.API_BASE_URL}/ManualJournals/updateManualJournalsLineItems`,
        POSTTRANSACTION: `${URL.API_BASE_URL}/ManualJournals/PostTransaction`,
        POSTTRANSACTIONSBATCH: `${URL.API_BASE_URL}/ManualJournals/PostTransactionsBatch`,
        POST_MANUAL_JOURNAL: `${URL.API_BASE_URL}/ManualJournals/PostManualJournal`,
        VOID_MANUAL_JOURNAL: `${URL.API_BASE_URL}/ManualJournals/VoidManualJournal`,
        MARKGLPOSTED: `${URL.API_BASE_URL}/ManualJournals/mark-gl-posted`,
        GL_TRANSACTION_TYPE: 'MANUAL_GENERAL',
        GL_VOID_TRANSACTION_TYPE: 'VOID_MANUAL_GENERAL',

    },

    VOUCHER: {
        //AUTOGENERATE_VOUCHERCODE: `${URL.API_BASE_URL}/Autogenerate/Voucher`,
        AUTOGENERATE_VOUCHERCODE: `${URL.API_BASE_URL}/Voucher/generateVoucherNumber`,
        CHECK_VOUCHER_NO: `${URL.API_BASE_URL}/Voucher/checkVoucherNo`,
        GET_VOUCHERS: `${URL.API_BASE_URL}/Voucher/getVoucher`,
        CREATE_VOUCHER: `${URL.API_BASE_URL}/Voucher/createVoucher`,
        UPDATE_VOUCHER: `${URL.API_BASE_URL}/Voucher/updateVoucher`,
        GET_VOUCHER_BY_ID: `${URL.API_BASE_URL}/Voucher/getVoucherById`,
        SEARCH_VOUCHER: `${URL.API_BASE_URL}/Voucher/searchVoucher`,
        DELETE_VOUCHER: `${URL.API_BASE_URL}/Voucher/deleteVoucher`,
        CREATE_VOUCHER_LINEITEM: `${URL.API_BASE_URL}/Voucher/createVoucherLineItem`,
        GET_VOUCHER_LINEITEMBYID: `${URL.API_BASE_URL}/Voucher/GetVoucherLineItemsById`,
        DELETE_VOUCHER_LINEITEM: `${URL.API_BASE_URL}/Voucher/deleteVoucherLineItems`,
        UPDATE_VOUCHER_LINEITEM: `${URL.API_BASE_URL}/Voucher/updateVoucherLineItems`,
        CREATE_ACCOUNTING_TRANSACTION: `${URL.API_BASE_URL}/Voucher/createVoucherAccountingTransaction`,
        UPDATE_ACCOUNTING_TRANSACTION: `${URL.API_BASE_URL}/Voucher/updateVoucherAccountingTransaction`,

    },

    TRANSACTIONSERIES: {
        GETNUMBERLIST: `${URL.API_BASE_URL}/Autogenerate/numberList`,
        UPDATENUMBER: `${URL.API_BASE_URL}/Autogenerate/updateNumber`,
        VALIDATE_NEXT_SO: `${URL.API_BASE_URL}/SalesOrder/validateNextNumber`,
        VALIDATE_NEXT_DC: `${URL.API_BASE_URL}/DeliveryChallan/validateNextDCNumber`,
        VALIDATE_NEXT_DEAL_CODE: `${URL.API_BASE_URL}/CRM/validateDealCode`,
        VALIDATE_NEXT_TASK_CODE: `${URL.API_BASE_URL}/CRM/validateTaskCode`,
        VALIDATE_NEXT_LEAD_CODE: `${URL.API_BASE_URL}/CRM/validateLeadCode`,
        VALIDATE_NEXT_CUSTOMER_CODE: `${URL.API_BASE_URL}/Customers/validateCustomerCode`,
        VALIDATE_NEXT_MATERIALREQUEST: `${URL.API_BASE_URL}/MaterialRequest/generateMaterialRequestNo`,

        VALIDATE_NEXT_VOUCHER: `${URL.API_BASE_URL}/Voucher/validateVoucherNumber`,
        VALIDATE_NEXT_VENDORBILL: `${URL.API_BASE_URL}/VendorBill/validateVendorBillNumber`,
        VALIDATE_NEXT_VENDORPAYMENT: `${URL.API_BASE_URL}/VendorPayment/ValidateVendorPaymentNumber`,
        VALIDATE_NEXT_PAYMENTRECIEPT: `${URL.API_BASE_URL}/PaymentReceipt/validatePaymentReceiptNumber`,
        VALIDATE_NEXT_PROPOSAL: `${URL.API_BASE_URL}/Proposal/validateProposalNumber`,
        VALIDATE_NEXT_PRODUCRREQUISITION: `${URL.API_BASE_URL}/ProductRequisition/validateProductRequisitionNumber`,
        VALIDATE_NEXT_PROJECT: `${URL.API_BASE_URL}/ProjectBOM/validateProjectNumber`,
        VALIDATE_NEXT_SERVICECALL: `${URL.API_BASE_URL}/ServiceCall/validateServiceCallNumber`,
        VALIDATE_NEXT_PROJECTPHASE: `${URL.API_BASE_URL}/ProjectPhase/validateProjectPhaseNumber`,
        VALIDATE_NEXT_PROJECTTASK: `${URL.API_BASE_URL}/ProjectTask/validateProjectTaskNumber`,
        VALIDATE_NEXT_TIMESHEETS: `${URL.API_BASE_URL}/Timesheet/validateProjectTimesheetsNumber`,
        VALIDATE_NEXT_VENDOR: `${URL.API_BASE_URL}/Vendor/validateVendorNumber`,
        VALIDATE_NEXT_RFQ: `${URL.API_BASE_URL}/RFQ/validateRfqNumber`,
        VALIDATE_NEXT_CUSTOMERS: `${URL.API_BASE_URL}/Customers/validateCustomersNumber`,
        VALIDATE_NEXT_SALESPERSON: `${URL.API_BASE_URL}/Salesperson/validateSalespersonNumber`,
        VALIDATE_NEXT_MANUFACTURINGBATCH: `${URL.API_BASE_URL}/ProjectManufacturingBatch/validateManufacturingBatchNumber`,
        VALIDATE_NEXT_STORECONSUMPTION: `${URL.API_BASE_URL}/StoreConsumption/validateStoreConsumptionNumber`,
        VALIDATE_NEXT_PROJECTBOM: `${URL.API_BASE_URL}/ProjectBillOfMaterial/validateProjectBOMNumber`,
        VALIDATE_NEXT_SALESRETURN: `${URL.API_BASE_URL}/SalesOrderReturn/validateSalesReturnNumber`,
        VALIDATE_NEXT_EWAYBILL: `${URL.API_BASE_URL}/EwayBill/validateEwayBillCode`,
    },

    // Project BOM APIs

    PROJECTASSEMBLY: {
        CREATE_PROJECTASSEMBLY: `${URL.API_BASE_URL}/ProjectBillOfMaterial/create`,
        GET_ALLPROJECTASSEMBLY: `${URL.API_BASE_URL}/ProjectBillOfMaterial/getAllProjectBOM`,
        GET_PROJECTASSEMBLYBYID: `${URL.API_BASE_URL}/ProjectBillOfMaterial/getProjectBOMById`,
        UPDATE_PROJECTASSEMBLY: `${URL.API_BASE_URL}/ProjectBillOfMaterial/updateProjectBOM`,
        DELETE_PROJECTASSEMBLY: `${URL.API_BASE_URL}/ProjectBillOfMaterial/delete`,
        SEARCHPROJECTBOMASSEMBLY: `${URL.API_BASE_URL}/ProjectBillOfMaterial/searchProjectbomAssembly`,
        AUTOGENERATE_PROJECTBOMCODE: `${URL.API_BASE_URL}/ProjectBillOfMaterial/generateProjectBOMNumber`,

    },
    MaterialRequest: {
        CREATE_MATERIALREQUEST: `${URL.API_BASE_URL}/MaterialRequest/Create`,
        UPDATE_MATERIALREQUEST: `${URL.API_BASE_URL}/MaterialRequest/update`,
        DELETE_MATERIALREQUEST: `${URL.API_BASE_URL}/MaterialRequest/delete`,
        GET_MATERIALREQUEST: `${URL.API_BASE_URL}/MaterialRequest/GetMaterialRequest`,
        GET_MATERIALREQUEST_BY_ID: `${URL.API_BASE_URL}/MaterialRequest/getMaterialRequestById`,
        SEARCH_MATERIALREQUEST: `${URL.API_BASE_URL}/MaterialRequest/search`,
        SEARCH_MATERIALISSUES: `${URL.API_BASE_URL}/MaterialRequest/searchMaterialIssues`,
        CHECK_MATERIALREQUEST_NUMBER: `${URL.API_BASE_URL}/MaterialRequest/checkMaterialRequestNo`,
        AUTOGENERATE_MATERIALREQUEST_NUMBER: `${URL.API_BASE_URL}/MaterialRequest/generateMaterialRequestNo`,
        UPDATE_MATERIALREQUESTBYCODE: `${URL.API_BASE_URL}/MaterialRequest/updateMaterialRequest`,
    },
    MaterialRequestLineItem: {
        CREATE: `${URL.API_BASE_URL}/MaterialRequest/createMaterialRequestLineItem`,
        UPDATE: `${URL.API_BASE_URL}/MaterialRequest/updateMaterialRequestLineItem`,
        UPDATEMATERIALREQUEST: `${URL.API_BASE_URL}/MaterialRequest/updateMaterialRequestLineItemByMRNoAndLineNo`,
        DELETE: `${URL.API_BASE_URL}/MaterialRequest/DeleteMaterialRequestLineItem`,
        GET: `${URL.API_BASE_URL}/MaterialRequest/getMaterialRequestLineItem`,
        GET_BY_ID: `${URL.API_BASE_URL}/MaterialRequest/getMaterialRequestLineItemById`,
        GET_MATERIALREQUEST_LINEITEMS: `${URL.API_BASE_URL}/MaterialRequest/getMaterialRequestLineItemByMaterialRequestNo`,
        GET_LAST_SPLIT: `${URL.API_BASE_URL}/MaterialRequest/getLastSplitMR`,
        GET_MATERIALREQUEST_LINEITEMS_ISSUEDQTY: `${URL.API_BASE_URL}/MaterialRequest/getTotalIssuedForSplits`,
    },
    MaterialIssues: {
        GET_MATERIALISSUES: `${URL.API_BASE_URL}/MaterialRequest/GetMaterialissues`,
        GET_BY_ID: `${URL.API_BASE_URL}/MaterialRequest/getMaterialIssuesById`,
        CREATE: `${URL.API_BASE_URL}/MaterialRequest/CreateMaterialIssues`,
        UPDATE: `${URL.API_BASE_URL}/MaterialRequest/updateMaterialIssues`,
        DELETE: `${URL.API_BASE_URL}/MaterialRequest/deleteMaterialIssues`,
        SEARCH: `${URL.API_BASE_URL}/MaterialRequest/searchMaterialIssues`,
    },

    MaterialIssueLineItem: {
        GET: `${URL.API_BASE_URL}/MaterialRequest/getMaterialIssueLineItem`,
        GET_BY_ID: `${URL.API_BASE_URL}/MaterialRequest/getMaterialIssueLineItemById`,
        CREATE: `${URL.API_BASE_URL}/MaterialRequest/createMaterialIssueLineItem`,
        UPDATE: `${URL.API_BASE_URL}/MaterialRequest/updateMaterialIssueLineItem`,
        DELETE: `${URL.API_BASE_URL}/MaterialRequest/DeleteMaterialIssueLineItem`,
        GET_MATERIALISSUES_LINEITEMS: `${URL.API_BASE_URL}/MaterialRequest/getMaterialIssuesLineItemByMaterialIssuesNo`,

    },

    //ModuleSetting
    MODULESETTINGS: {
        GET_ALLPUSERANDROLES: `${URL.API_BASE_URL}/ModuleSettings/getUsers`,
        GET_APPROVALMODULES: `${URL.API_BASE_URL}/ModuleSettings/getApprovalModules`,
        CREATE_APPROVAL: `${URL.API_BASE_URL}/ModuleSettings/saveApprovalConfig`,
        GET_APPROVALSETTINGS: `${URL.API_BASE_URL}/ModuleSettings/getAllApprovalSettings`,

        DELETE_APPROVAL: `${URL.API_BASE_URL}/ModuleSettings/deleteApprovalLevel`,
    },
    //Warehouse
    WAREHOUSE: {
        GETDEPARTMENTS: `${URL.API_BASE_URL}/Warehouse/getDepartments`,
        GETTRANSACTIONTYPES: `${URL.API_BASE_URL}/Warehouse/getTransactionTypes`,
        CREATEDEPARTMENTDEFAULT: `${URL.API_BASE_URL}/Warehouse/SaveDepartmentDefaults`,
        GETDEPARTMENTDEAFULT: `${URL.API_BASE_URL}/Warehouse/GetDepartmentDefaults`,
    },
    REMINDER: {
        CREATE_REMINDER: `${URL.API_BASE_URL}/InvoiceReminder/Create`,
        GET_REMINDER: `${URL.API_BASE_URL}/InvoiceReminder/GetInvoiceReminder`,
        GET_BILLREMINDER: `${URL.API_BASE_URL}/InvoiceReminder/GetBillReminder`,
        UPDATE_REMINDER: `${URL.API_BASE_URL}/InvoiceReminder/update`,
        DELETE_REMINDER: `${URL.API_BASE_URL}/InvoiceReminder/delete`,
        GET_REMINDER_BY_ID: `${URL.API_BASE_URL}/InvoiceReminder/GetInvoiceReminderById`,
        SEND_ACTIVE_REMINDERS: `${URL.API_BASE_URL}/Mail/ProcessInvoiceReminders`,
    },
    EINVOICE: {
        GENERATE_EINVOICE: `${URL.API_BASE_URL}/EInvoice/generate`,
        RETRY_EINVOICE: `${URL.API_BASE_URL}/EInvoice/retry`,
        CANCEL_EINVOICE: `${URL.API_BASE_URL}/EInvoice/cancel-irn`,
        GET_ALL: `${URL.API_BASE_URL}/EInvoice`,
        DOWNLOAD_PDF: `${URL.API_BASE_URL}/EInvoice/pdf`,
        VALIDATE_EINVOICE: `${URL.API_BASE_URL}/EInvoice/validate`,

        SAVE_EINVOICESETTINGS: `${URL.API_BASE_URL}/EInvoice/SaveSettings`,
        UPDATE_EINVOICESETTINGS: `${URL.API_BASE_URL}/EInvoice/UpdateSettings`,
        DISABLE_EINVOICESETTINGS: `${URL.API_BASE_URL}/EInvoice/DisableSettings`,
        GET_SETTINGS: `${URL.API_BASE_URL}/EInvoice/GetSettings`,
        GET_EINVOICE_STATUS: `${URL.API_BASE_URL}/EInvoice/GetEInvoiceStatus`,
    },
    EWAYBILL: {
        GET_CUSTOMERS: `${URL.API_BASE_URL}/EwayBill/GetCustomers`,
        GET_INVOICES: `${URL.API_BASE_URL}/EwayBill/GetSuccessInvoicesWithItems`,
        GET_TRANSPORTS: `${URL.API_BASE_URL}/EwayBill/GetTransporters`,
        GET_TRANSPORTER_BY_ID: `${URL.API_BASE_URL}/EwayBill/GetTransporterById`,
        CREATE_TRANSPORTER: `${URL.API_BASE_URL}/EwayBill/CreateTransporter`,

        CREATE_EWAYBILL: `${URL.API_BASE_URL}/EwayBill/createEWayBill`,
        UPDATE_EWAYBILL: `${URL.API_BASE_URL}/EwayBill/updateewaybill`,
        UPDATE_STATUS: `${URL.API_BASE_URL}/EwayBill/update-status`,

        GENERATE_EWAYBILL: `${URL.API_BASE_URL}/EwayBill/generate-ewaybill`,


        GET_EWAYBILLLIST: `${URL.API_BASE_URL}/EwayBill/GetEWayBill`,
        GET_CUSTOMERSFOREINVOICE: `${URL.API_BASE_URL}/EwayBill/GetCustomersWithSuccessfulEInvoice`,
        GET_EWAYBILL_BY_ID: `${URL.API_BASE_URL}/EWayBill/GetEWayBillById`,
        SEARCH_EWAYBILL: `${URL.API_BASE_URL}/EWayBill/searchEWayBill`,
        DELETE_EWAYBILL: `${URL.API_BASE_URL}/EWayBill/deleteEWayBill`,

        CHECK_EWAY_CODE: `${URL.API_BASE_URL}/EWayBill/CheckEwayBillCode`,
        AUTOGENERATE_EWAY_CODE: `${URL.API_BASE_URL}/EWayBill/generateEwayBillCode`,
        GET_SALESORDER_LINEITEMS_BY_NUMBER: `${URL.API_BASE_URL}/EWayBill/getSalesOrderLineItems`,
        CANCEL_EWAYBILL: `${URL.API_BASE_URL}/EWayBill/cancel`,
        VALIDATE_EWAYBILL: `${URL.API_BASE_URL}/EWayBill/validate-ewaybill`,
        //update vehicle
        UPDATE_VEHICLE: `${URL.API_BASE_URL}/EWayBill/UpdateVehicle`,
        //extendValidity
        EXTEND_VALIDITY: `${URL.API_BASE_URL}/EWayBill/ExtendValidity`,
    },
 ONBOARDING: {
        SAVE: `${URL.API_BASE_URL}/HRMS/saveOnboarding`,
        GET_ALL: `${URL.API_BASE_URL}/HRMS/getOnboardings`,
        GET_BY_ID: `${URL.API_BASE_URL}/HRMS/getOnboardingById`,
        UPDATE: `${URL.API_BASE_URL}/HRMS/updateOnboarding`,
       DELETE: `${URL.API_BASE_URL}/HRMS/deleteOnboard`,
        STATUS: `${URL.API_BASE_URL}/HRMS/updateOnboardingStatus`,
        SEARCH: `${URL.API_BASE_URL}/HRMS/searchOnboarding`,
        UPLOAD_RESUME: `${URL.API_BASE_URL}/HRMS/uploadOnboardingResume`,
    },
	
	
    ANNOUNCEMENT: {
        CREATE_ANNOUNCEMENT: `${URL.API_BASE_URL}/HRMS/CreateAnnouncement`,
        GET_ANNOUNCEMENT: `${URL.API_BASE_URL}/HRMS/GetAnnouncement`,
        GET_ANNOUNCEMENT_BYID: `${URL.API_BASE_URL}/HRMS/GetAnnouncementById`,
        UPDATE_ANNOUNCEMENT: `${URL.API_BASE_URL}/HRMS/UpdateAnnouncement`,
        DELETE_ANNOUNCEMENT: `${URL.API_BASE_URL}/HRMS/DeleteAnnouncement`,
        AUTOSEARCH_ANNOUNCEMENT: `${URL.API_BASE_URL}/HRMS/SearchAnnouncement`,
        UPLOAD_ATTACHMENT: `${URL.API_BASE_URL}/HRMS/UploadAnnouncementAttachment`,
    },

    SURVEY: {
        CREATE_SURVEY: `${URL.API_BASE_URL}/HRMS/CreateSurvey`,
        GET_SURVEYS: `${URL.API_BASE_URL}/HRMS/GetSurveys`,
        GET_SURVEY_BYID: `${URL.API_BASE_URL}/HRMS/GetSurveyById`,
        UPDATE_SURVEY: `${URL.API_BASE_URL}/HRMS/UpdateSurvey`,
        DELETE_SURVEY: `${URL.API_BASE_URL}/HRMS/DeleteSurvey`,
        AUTOSEARCH_SURVEY: `${URL.API_BASE_URL}/HRMS/SearchSurvey`,
    },

    HOLIDAY: {
        CREATE_HOLIDAY: `${URL.API_BASE_URL}/HRMS/CreateHoliday`,
        GET_HOLIDAYS: `${URL.API_BASE_URL}/HRMS/GetHolidays`,
        GET_HOLIDAY_BYID: `${URL.API_BASE_URL}/HRMS/GetHolidayById`,
        UPDATE_HOLIDAY: `${URL.API_BASE_URL}/HRMS/UpdateHoliday`,
        DELETE_HOLIDAY: `${URL.API_BASE_URL}/HRMS/DeleteHoliday`,
        AUTOSEARCH_HOLIDAY: `${URL.API_BASE_URL}/HRMS/SearchHoliday`,
    },


    SURVEY_QUESTION: {
        CREATE_SURVEY_QUESTION: `${URL.API_BASE_URL}/HRMS/CreateSurveyQuestion`,
        GET_SURVEY_QUESTIONS: `${URL.API_BASE_URL}/HRMS/GetSurveyQuestions`,
        GET_ALL_SURVEY_QUESTIONS: `${URL.API_BASE_URL}/HRMS/GetSurveyQuestions`,
        GET_SURVEY_QUESTION_BYID: `${URL.API_BASE_URL}/HRMS/GetSurveyQuestionById`,
        UPDATE_SURVEY_QUESTION: `${URL.API_BASE_URL}/HRMS/UpdateSurveyQuestion`,
        DELETE_SURVEY_QUESTION: `${URL.API_BASE_URL}/HRMS/DeleteSurveyQuestion`,
        AUTOSEARCH_SURVEY_QUESTION: `${URL.API_BASE_URL}/HRMS/SearchSurveyQuestion`,
    },
    FINANCIALYEAR: {
        GETALLFINANCIALYEAR: `${URL.API_BASE_URL}/FinancialYear/getFinancialYears`,
        GETFINANCIALYEARBYID: `${URL.API_BASE_URL}/FinancialYear/getFinancialYearById`,
        CREATEFINANCIALYEAR: `${URL.API_BASE_URL}/FinancialYear/create`,
        //UPDATEFINANCIALYEAR: `${URL.API_BASE_URL}/FinancialYear/update`,
        DELETEFINANCIALYEAR: `${URL.API_BASE_URL}/FinancialYear/delete`,
        LOCKFINANCIALYEAR: `${URL.API_BASE_URL}/FinancialYear/lock`,
        CLOSEFINANCIALYEAR: `${URL.API_BASE_URL}/FinancialYear/close`,
        REOPENFINANCIALYEAR: `${URL.API_BASE_URL}/FinancialYear/reopen`,
        UPDATEFINANCIALYEAR: `${URL.API_BASE_URL}/FinancialYear/update`,
        VALIDATEFINANCIALYEAR: `${URL.API_BASE_URL}/FinancialYear/validate`,
        GETCURRENTFY: `${URL.API_BASE_URL}/FinancialYear/current`,
    },


   FILES: {
        GET_FILES: `${URL.API_BASE_URL}/HRMS/GetFiles`,
        DELETE_FILE: `${URL.API_BASE_URL}/HRMS/DeleteFile`,
        GET_FILES_BY_EMPLOYEE: `${URL.API_BASE_URL}/HRMS/GetFilesByEmployee`,
        UPLOAD_AND_SAVE_FILE: `${URL.API_BASE_URL}/HRMS/UploadAndSaveFile`,
        DOWNLOAD_FILE: `${URL.API_BASE_URL} /HRMS/downloadFile`,
    },


    ANNOUNCEMENT_FILES: {
        DOWNLOAD_FILE: `${URL.API_BASE_URL}/HRMS/downloadFile`,
        DOWNLOAD_ATTACHMENT: `${URL.API_BASE_URL}/HRMS/downloadAttachment`,

    },

    HR_FILES: {
        UPLOAD_HR_FILE: `${URL.API_BASE_URL}/HRMS/UploadHrFile`,
        DOWNLOAD_HR_FILE: `${URL.API_BASE_URL}/HRMS/DownloadHrFile`,
    },


    HR_DOCUMENT_FILES: {
        UPLOAD_HR_FILE: `${URL.API_BASE_URL}/HRMS/UploadHrFile`,
        DOWNLOAD_SHARED_HR_FILE: `${URL.API_BASE_URL}/HRMS/DownloadSharedHrFile`,
        UPLOAD_AND_SAVE_HR_FILE: `${URL.API_BASE_URL}/HRMS/UploadAndSaveHrFile`,
        GET_SHARED_HR_FILES: `${URL.API_BASE_URL}/HRMS/GetSharedHrFiles`,
        LINK_HR_FILE: `${URL.API_BASE_URL}/HRMS/LinkHrFile`,
        DELETE_SHARED_HR_FILE: `${URL.API_BASE_URL}/HRMS/DeleteSharedHrFile`,
        GET_HR_FILES_BY_EMPLOYEE: `${URL.API_BASE_URL}/HRMS/GetHrFilesByEmployee`,
    },

    ASSETS: {
        GET_ASSETS: `${URL.API_BASE_URL}/HRMS/getAssets`,
        GET_ASSET_BY_ID: `${URL.API_BASE_URL}/HRMS/getAssetById`,
        GET_ASSETS_BY_CATEGORY: `${URL.API_BASE_URL}/HRMS/getAssetsByCategory`,
        SAVE_ASSET: `${URL.API_BASE_URL}/HRMS/saveAsset`,
        UPDATE_ASSET: `${URL.API_BASE_URL}/HRMS/updateAsset`,
        DELETE_ASSETS: `${URL.API_BASE_URL}/HRMS/deleteAssets`,
    },

    ASSET_CATEGORIES: {
            GET_CATEGORIES: `${URL.API_BASE_URL}/HRMS/getAssetCategories`,
            SAVE_CATEGORY: `${URL.API_BASE_URL}/HRMS/saveAssetCategory`,
            UPDATE_CATEGORY: `${URL.API_BASE_URL}/HRMS/updateAssetCategory`,
            GET_PERCENTAGES: `${URL.API_BASE_URL}/HRMS/categories/percentages`,
            GET_STATUS_COUNTS: `${URL.API_BASE_URL}/HRMS/assets/status-counts`,
         },
 

}
